{
    "DATE": {
        "YESTERDAY": "Gisteren",
        "TODAY": "Vandaag",
        "TOMORROW": "Morgen"
    },
    "ENUM": {
        "CLIENT_TYPE": {
            "DEBT_MEDIATION": {
                "LABEL": "Schuldbemiddeling",
                "ICON": "debt-mediation"
            },
            "FINANCIAL_MANAGEMENT": {
                "LABEL": "Bewindvoering",
                "ICON": "guardianship"
            },
            "SOCIAL_RENT": {
                "LABEL": "Sociale verhuur",
                "ICON": "social-rent"
            },
            "BUDGET_GUIDANCE": {
                "LABEL": "Budgetbegeleiding",
                "ICON": "budget-management"
            },
            "RENT": {
                "LABEL": "Verhuur",
                "ICON": "rent"
            },
            "PCSW": {
                "LABEL": "OCMW",
                "ICON": "pcsw"
            }
        },
        "BANK_ACCOUNT_OWNER_TYPE": {
            "CLIENT": {
                "ICON": "clients"
            },
            "OFFICE": {
                "ICON": "office-account"
            }
        },
        "BANK_ACCOUNT_TYPE": {
            "BASE": {
                "LABEL": "Basisrekening"
            },
            "RESERVE": {
                "LABEL": "Reserverekening"
            },
            "SAVINGS": {
                "LABEL": "Spaarrekening"
            },
            "ALLOWANCE": {
                "LABEL": "Leefgeldrekening"
            },
            "SECURITY": {
                "LABEL": "Waarborgrekening"
            },
            "VAPH": {
                "LABEL": "VAPH rekening"
            },
            "INVEST": {
                "LABEL": "Investeringsrekening"
            }
        },
        "LANGUAGE": {
            "NL": "Nederlands",
            "FR": "Frans",
            "EN": "Engels"
        },
        "MOBILE_APP_USER_LOGIN_TYPE": {
            "PHONE": {
                "LABEL": "GSM-nummer"
            },
            "EMAIL": {
                "LABEL": "E-mail"
            }
        }
    },
    "TOAST": {
        "INFO": {
            "UPDATE_AVAILABLE": {
                "TITLE": "Update beschikbaar!",
                "MESSAGE": "Klik hier of ververs de pagina om de nieuwe versie te laden."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Document wordt gegenereerd",
                "MESSAGE": "Je wordt op de hoogte gebracht wanneer het document klaar is."
            }
        },
        "ERROR": {
            "UNKNOWN": {
                "TITLE": "Onbekende fout"
            },
            "BAD_REQUEST": {
                "TITLE": "Foutief verzoek"
            },
            "FORBIDDEN": {
                "TITLE": "Verboden"
            },
            "NOT_FOUND": {
                "TITLE": "Niet gevonden"
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "Upload van documenten is mislukt"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "Genereren van rapport is mislukt"
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Genereren van document is mislukt"
            }
        },
        "SUCCESS": {
            "ADD_CLIENT": {
                "TITLE": "Cliënt met succes aangemaakt"
            },
            "INFO_SAVED": {
                "TITLE": "Basisinfo werd bijgewerkt"
            },
            "CLIENT_ACCOUNTS_SAVED": {
                "TITLE": "Bankrekeningen werden bijgewerkt"
            },
            "ACCOUNT_CLIENT_SETTINGS_SAVED": {
                "TITLE": "Cliëntinstellingen werden bijgewerkt"
            },
            "TRANSACTION": {
                "CATEGORY": {
                    "SAVED": {
                        "TITLE": "Categorie werd bijgewerkt",
                        "ALL_CLIENTS": {
                            "TITLE": "Categorie werd bijgewerkt",
                            "MESSAGE": "De categorie werd ingesteld op alle rekeningen van de gekoppelde cliënt. De verwerking van de andere rekeningen is gestart in de achtergrond."
                        }
                    }
                }
            },
            "CLIENT_ARCHIVED": {
                "TITLE": "Cliënt werd gearchiveerd"
            },
            "CLIENT_RESTORED": {
                "TITLE": "Cliënt werd hersteld"
            },
            "PDF_EXPORTED": {
                "TITLE": "De PDF export werd gedownload."
            },
            "XLSX_EXPORTED": {
                "TITLE": "De Excel export werd gedownload."
            },
            "BANK_ACCOUNT_ARCHIVED": {
                "TITLE": "Rekening werd gearchiveerd"
            },
            "BANK_ACCOUNT_RESTORED": {
                "TITLE": "Rekening werd hersteld"
            },
            "DOCUMENT_DOWNLOADED": {
                "TITLE": "Document werd gedownload"
            },
            "DOCUMENT_RESPONSE_ADDED": {
                "TITLE": "Betaalverzoek werd beantwoord"
            },
            "TRANSACTION_TAGS_SAVED": {
                "TITLE": "Tags werden bijgewerkt"
            },
            "DOSSIER_SAVED": {
                "TITLE": "Dossier werd bijgewerkt"
            },
            "DIVIDEND_CREATED": {
                "TITLE": "Betalingen zijn aangemaakt"
            },
            "RB_DOCUMENT_CREATED": {
                "TITLE": "Documentgeneratie wordt uitgevoerd. Het document wordt toegevoegd aan de lijst met documenten na voltooing"
            },
            "UPLOAD_DOCUMENTS": {
                "TITLE": "Documenten zijn geüpload"
            },
            "PAYMENT_SAVED": {
                "TITLE": "De betaling werd opgeslagen"
            },
            "DOCUMENT_RENAMED": {
                "TITLE": "Document werd hernoemd"
            },
            "DOCUMENT_DELETED": {
                "TITLE": "Documenten werden verwijderd"
            },
            "DOCUMENT_UPDATED": {
                "TITLE": "Document werd geüpdatet"
            },
            "PAYMENT_DELETED": {
                "TITLE": "Betaling werd verwijderd"
            },
            "CLIENT_APPLICATION_INVITATION": {
                "TITLE": "Uitnodiging werd verstuurd"
            },
            "ACCOUNT_USER_SAVED": {
                "TITLE": "Persoonsgegevens werden bijgewerkt"
            },
            "PASSWORD_SAVED": {
                "TITLE": "Wachtwoord werd geüpdatet"
            },
            "OFFICE_SAVED": {
                "TITLE": "Kantoor werd bijgewerkt"
            },
            "OFFICE_USER_ADDED": {
                "TITLE": "Gebruiker werd toegevoegd",
                "MESSAGE": "Een uitnodiging werd verstuurd via e-mail."
            },
            "OFFICE_USER_UPDATED": {
                "TITLE": "Gebruiker werd bijgewerkt"
            },
            "REDIRECTING_TO_FINANCIAL_INSTITUTION": {
                "TITLE": "Je wordt doorverwezen naar de bank"
            },
            "REDIRECTING_TO_ISABEL": {
                "TITLE": "Je wordt doorverwezen naar Isabel 6"
            },
            "CREDITORS_IMPORTED": {
                "TITLE": "Schuldeisers werden geïmporteerd"
            },
            "CREATE_ACTIVE_DEBT_DOSSIERS_REPORT": {
                "TITLE": "Rapport is gegenereerd"
            },
            "DOCUMENT_ASSIGNED": {
                "TITLE": "Documenten zijn toegewezen"
            },
            "NOTIFICATIONS_PROCESSED": {
                "TITLE": "Meldingen werden afgesloten"
            },
            "PAYMENTS_SUBMITTED": {
                "TITLE": "Betalingen werden ingediend bij Isabel 6"
            },
            "PASSWORD_UPDATED": {
                "TITLE": "Controleer je e-mail",
                "MESSAGE": "Je ontvangt een e-mail met instructies om een nieuw wachtwoord in te stellen."
            },
            "OFFICE_TRANSACTION_CATEGORY_ADDED": {
                "TITLE": "Categorie toegevoegd"
            },
            "OFFICE_TRANSACTION_CATEGORY_UPDATED": {
                "TITLE": "Categorie gewijzigd"
            },
            "OFFICE_TRANSACTION_CATEGORY_DELETED": {
                "TITLE": "Categorie verwijderd"
            },
            "BUDGET_SAVED": {
                "TITLE": "Budget opgeslagen",
                "MESSAGE": "Het budget werd succesvol opgeslagen."
            },
            "CREATE_RB_DOCUMENT": {
                "TITLE": "Document gegenereerd",
                "MESSAGE": "Het document is klaar en werd toegevoegd aan de lijst.",
                "LINK": "Bekijken"
            }
        },
        "WARNING": {
            "PDF_NOT_EXPORTED": {
                "TITLE": "PDF export is beperkt tot 3000 verrichtingen. Pas de filters aan."
            },
            "XLSX_NOT_EXPORTED": {
                "TITLE": "Excel export is beperkt tot 3000 verrichtingen. Pas de filters aan."
            },
            "MAX_UPLOAD_FILE_SIZE": {
                "TITLE": "Maximale bestandsgrootte overschreden",
                "MESSAGE": "Enkel bestanden kleiner dan 20MB kunnen toegevoegd worden."
            },
            "MAX_UPLOAD_REQUEST_SIZE": {
                "TITLE": "Maximale grootte upload overschreden",
                "MESSAGE": "De totale grootte van een upload moet kleiner zijn dan 200 MB."
            },
            "FILE_TYPE": {
                "TITLE": "Bestandstype wordt niet ondersteund"
            }
        }
    },
    "LOGIN": {
        "HEADER": "Inloggen",
        "FORM": {
            "FIELD": {
                "USERNAME": {
                    "PLACEHOLDER": "E-mail",
                    "ERROR": {
                        "REQUIRED": "Vereist",
                        "EMAIL": "Ongeldig e-mailadres"
                    }
                },
                "PASSWORD": {
                    "PLACEHOLDER": "Wachtwoord",
                    "ERROR": {
                        "REQUIRED": "Vereist",
                        "INVALID": "Ongeldig e-mailadres en/of wachtwoord"
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Inloggen"
                }
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "Je gaat inloggen bij kantoor &quot;<strong>{{ office }}</strong>&quot;"
        },
        "SUCCESS": {
            "TITLE": "Aangemeld",
            "LINK": "Klik hier als je niet automatisch wordt doorverwezen"
        },
        "ERROR": {
            "TITLE": "Aanmeldingsfout",
            "BUTTON": "Opnieuw aanmelden"
        }
    },
    "APP": {
        "SIDENAV": {
            "MENU": {
                "ITEM": {
                    "DASHBOARD": {
                        "LABEL": "Dashboard",
                        "TOOLTIP": "Dashboard"
                    },
                    "CLIENTS": {
                        "LABEL": "Cliënten",
                        "TOOLTIP": "Cliënten"
                    },
                    "MESSAGES": {
                        "LABEL": "Berichten",
                        "TOOLTIP": "Berichten"
                    },
                    "CONTACTS": {
                        "LABEL": "Contacten",
                        "TOOLTIP": "Contacten"
                    },
                    "BANK_ACCOUNTS": {
                        "LABEL": "Rekeningen",
                        "TOOLTIP": "Rekeningen"
                    },
                    "PAYMENTS": {
                        "LABEL": "Betalingen",
                        "TOOLTIP": "Betalingen"
                    },
                    "NOTIFICATIONS": {
                        "LABEL": "Meldingen",
                        "TOOLTIP": "Meldingen"
                    },
                    "OTHER": {
                        "LABEL": "Overige",
                        "TOOLTIP": "Overige",
                        "MENU": {
                            "ITEM": {
                                "ACTIONS": {
                                    "LABEL": "Acties",
                                    "TOOLTIP": "Acties"
                                },
                                "ARCHIVE": {
                                    "MENU": {
                                        "ITEM": {
                                            "CLIENTS": {
                                                "LABEL": "Archief cliënten",
                                                "TOOLTIP": "Archief cliënten"
                                            },
                                            "BANK_ACCOUNTS": {
                                                "LABEL": "Archief rekeningen",
                                                "TOOLTIP": "Archief rekeningen"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "OFFICE": {
                        "LABEL": "Mijn kantoor",
                        "TOOLTIP": "Mijn kantoor"
                    },
                    "PROFILE": {
                        "LABEL": "Mijn profiel",
                        "TOOLTIP": "Mijn profiel"
                    },
                    "SETTINGS": {
                        "LABEL": "Instellingen",
                        "TOOLTIP": "Instellingen"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documenten",
                        "TOOLTIP": "Documenten"
                    }
                },
                "ACTION": {
                    "LOGOUT": {
                        "LABEL": "Uitloggen",
                        "TOOLTIP": "Uitloggen"
                    },
                    "ISABEL": {
                        "TOOLTIP": "Isabel 6 Customer Zone"
                    },
                    "COLLAPSE": {
                        "LABEL": "Samenvouwen",
                        "TOOLTIP": "Uitklappen"
                    },
                    "HELPDESK": {
                        "LABEL": "Helpdesk",
                        "TOOLTIP": "Helpdesk",
                        "URL": "https://roov.app/nl/helpdesk/1"
                    }
                }
            }
        },
        "ACTIONS": {
            "HEADER": {
                "LABEL": "Acties"
            }
        },
        "ARCHIVE": {
            "BANK_ACCOUNTS": {
                "HEADER": {
                    "LABEL": "Archief rekeningen"
                }
            },
            "CLIENTS": {
                "HEADER": {
                    "LABEL": "Archief cliënten"
                }
            }
        },
        "BANK_ACCOUNTS": {
            "HEADER": {
                "LABEL": "Rekeningen"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Zoeken"
                },
                "LINKED": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle rekeningen"
                        },
                        "TRUE": {
                            "LABEL": "Gekoppeld"
                        },
                        "FALSE": {
                            "LABEL": "Ongekoppeld"
                        }
                    }
                },
                "WITH_WARNING": {
                    "LABEL": "Met waarschuwing"
                },
                "FINANCIAL_INSTITUTION": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle banken"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Rekening toevoegen"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "FINANCIAL_INSTITUTION": {
                        "HEADER": {
                            "LABEL": "Bank"
                        }
                    },
                    "LABEL": {
                        "HEADER": {
                            "LABEL": "Rekening"
                        }
                    },
                    "IBAN": {
                        "HEADER": {
                            "LABEL": "Rekeningnummer"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Saldo"
                        }
                    },
                    "SYNCHRONIZED_AT": {
                        "HEADER": {
                            "LABEL": "Gesynchroniseerd"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Gekoppeld aan"
                        }
                    },
                    "LATEST_TRANSACTION": {
                        "HEADER": {
                            "LABEL": "Laatste verrichting"
                        }
                    }
                },
                "EMPTY": "Geen rekeningen gevonden"
            },
            "WARNINGS": {
                "ARCHIVED": "Gearchiveerd",
                "AUTH_INVALID": "Ongeldige autorisatie",
                "EXPIRING": "Autorisatie vervalt",
                "MOVED_TO_ISABEL": "Bank gemigreerd naar Isabel Connect",
                "TECHNICAL_FAILURE": "Tijdelijk technisch probleem",
                "NOT_FOUND_ISABEL": "Niet beschikbaar via Isabel Connect",
                "BLOCKED": "Gebruiker werd geblokkeerd"
            },
            "API_PRODUCT": {
                "ISABEL": {
                    "TOOLTIP": "Gekoppeld via Isabel Connect"
                },
                "IMPORT": {
                    "TOOLTIP": "Geïmporteerd, niet actief gekoppeld"
                }
            }
        },
        "CLIENTS": {
            "HEADER": {
                "LABEL": "Cliënten"
            },
            "FILTER": {
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Zoeken"
                },
                "CLIENT_TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle cliënttypes"
                        }
                    }
                },
                "OPEN_NOTIFICATIONS_ONLY": {
                    "LABEL": "Enkel open meldingen"
                },
                "USER": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle cliënten"
                        },
                        "MY": {
                            "LABEL": "Mijn cliënten"
                        },
                        "OTHER": {
                            "LABEL": "Cliënten van"
                        }
                    }
                }
            },
            "BUTTON": {
                "ADD": {
                    "LABEL": "Cliënt toevoegen"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "NAME": {
                        "HEADER": {
                            "LABEL": "Cliënt"
                        }
                    },
                    "LAST_NOTIFICATION": {
                        "HEADER": {
                            "LABEL": "Laatste melding"
                        },
                        "SUBTITLE": "{{count}} open"
                    },
                    "BANK_ACCOUNTS": {
                        "HEADER": {
                            "LABEL": "Rekeningen"
                        },
                        "WARNING": {
                            "TOOLTIP": "Deze rekening dreigt te vervallen"
                        }
                    },
                    "BALANCE": {
                        "HEADER": {
                            "LABEL": "Saldo"
                        }
                    }
                },
                "EMPTY": "Geen cliënten gevonden"
            },
            "CLIENT": {
                "BREADCRUMB": {
                    "LABEL": "Cliënten"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": {
                        "LABEL": "Rekeningen"
                    },
                    "EMPTY": "Geen rekeningen beschikbaar"
                },
                "TAB": {
                    "NOTIFICATIONS": {
                        "LABEL": "Meldingen",
                        "ONLY_UNPROCESSED": {
                            "LABEL": "Enkel open meldingen"
                        },
                        "TABLE": {
                            "COLUMN": {
                                "ACCOUNT": {
                                    "HEADER": {
                                        "LABEL": "Bankrekening"
                                    }
                                },
                                "NOTIFICATION": {
                                    "HEADER": {
                                        "LABEL": "Melding"
                                    },
                                    "ACCEPTED": "Aanvaarden",
                                    "DECLINED": "Afwijzen"
                                },
                                "CLOSED": {
                                    "HEADER": {
                                        "LABEL": "Gesloten"
                                    }
                                }
                            },
                            "EMPTY": "Geen meldingen gevonden"
                        },
                        "PROCESS_NOTIFICATIONS": {
                            "LABEL": "Alles afsluiten"
                        }
                    },
                    "INFO": {
                        "LABEL": "Basisinfo"
                    },
                    "DOSSIER": {
                        "LABEL": "Dossier"
                    },
                    "DOCUMENTS": {
                        "LABEL": "Documenten"
                    },
                    "APPLICATION": {
                        "LABEL": "Cliëntenapp"
                    },
                    "DOSSIER_DEBT_MEDIATION": {
                        "LABEL": "CSR"
                    },
                    "DOSSIER_FINANCIAL_MANAGEMENT": {
                        "LABEL": "Bewind"
                    },
                    "BUDGET": {
                        "LABEL": "Budget"
                    }
                },
                "SET_ARCHIVED_STATUS": {
                    "DIALOG": {
                        "TITLE": "Archiveren",
                        "STATUS": {
                            "TITLE": "Status",
                            "ACTIVE": "Actief",
                            "ARCHIVED": "Gearchiveerd op {{ date }}"
                        },
                        "ACTION": {
                            "TITLE": "Actie",
                            "ACTIVE": "Archiveren",
                            "ARCHIVED": "Herstellen"
                        },
                        "INFO": {
                            "ARCHIVED": "Het herstellen van een cliënt houdt in:\n<ul>\n<li>De cliënt wordt opnieuw getoond in de lijst van actieve cliënten.</li>\n<li>Basisinfo en dossiergegevens kunnen terug aangepast worden.</li>\n<li>Er kunnen weer documenten geüpload of gegenereerd worden.</li>\n<li>Een nieuwe koppeling met de cliëntenapp kan gemaakt worden (een eventuele eerdere koppeling wordt niet hersteld).</li>\n<li>Het is opnieuw mogelijk bankrekening te koppelen aan of los te koppelen van deze cliënt.</li>\n<li>Gekoppelde bankrekeningen blijven gearchiveerd, maar kunnen afzonderlijk hersteld worden.</li>\n<li>Er kunnen weer nieuwe meldingen voor deze cliënt opduiken.</li>\n</ul>",
                            "ACTIVE": "Het archiveren van een cliënt houdt in:\n<ul>\n<li>De cliënt wordt niet meer getoond in de lijst van actieve cliënten.</li>\n<li>Basisinfo en dossiergegevens kunnen niet meer aangepast worden.</li>\n<li>Er kunnen geen documenten meer geüpload of gegenereerd worden.</li>\n<li>Een eventuele koppeling met de cliëntenapp wordt verbroken en rekeninginfo dus niet langer gedeeld.</li>\n<li>Het is niet langer mogelijk bankrekeningen te koppelen aan of los te koppelen van deze cliënt.</li>\n<li>Alle gekoppelde bankrekeningen worden gearchiveerd en dus niet langer gesynchroniseerd.</li>\n<li>Alle openstaande meldingen worden afgesloten en er worden geen nieuwe meldingen meer aangemaakt.</li>\n</ul>"
                        }
                    }
                }
            },
            "ADD_CLIENT_DIALOG": {
                "TITLE": "Nieuwe cliënt",
                "CONTENT": {
                    "INFO": {
                        "HEADER": "Basisinfo"
                    },
                    "TYPE": {
                        "HEADER": "Type",
                        "FORM": {
                            "FIELD": {
                                "TYPE": {
                                    "ERROR": {
                                        "REQUIRED": "Vereist"
                                    }
                                }
                            }
                        }
                    }
                },
                "BUTTON": {
                    "CONFIRM": {
                        "LABEL": "Bevestigen"
                    },
                    "CANCEL": {
                        "LABEL": "Annuleren"
                    }
                }
            },
            "CLIENT_INFO": {
                "EDIT": {
                    "DIALOG": {
                        "FIELD": {
                            "EMAIL": {
                                "ERROR": {
                                    "REQUIRED": "Vereist",
                                    "EMAIL": "Ongeldig e-mailadres"
                                }
                            },
                            "FIRSTNAME": {
                                "ERROR": {
                                    "REQUIRED": "Vereist"
                                }
                            },
                            "SSN": {
                                "ERROR": {
                                    "INPUT_MASK": "Ongeldig rijksregisternummer"
                                }
                            },
                            "DATE_OF_BIRTH": {
                                "ERROR": {
                                    "MAT_DATEPICKER_PARSE": "Ongeldige datum",
                                    "MAT_DATEPICKER_MAX": "Datum in de toekomst niet toegelaten",
                                    "INPUT_MASK": "Ongeldige datum"
                                }
                            }
                        },
                        "TITLE": "Basisinfo",
                        "ERROR": {
                            "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                            "EMAIL": "Ongeldig e-mailadres",
                            "INPUT_MASK": "Ongeldig rijksregisternummer",
                            "MAT_DATEPICKER_PARSE": "Ongeldige datum",
                            "MAT_DATEPICKER_MAX": "Datum in de toekomst niet toegelaten"
                        }
                    },
                    "LABEL": "Bewerken"
                },
                "PERSONAL_INFO": {
                    "FIRSTNAME": "Voornaam",
                    "LASTNAME": "Familienaam",
                    "STREET": "Straat",
                    "HEADER": "Persoonsgegevens",
                    "NUMBER": "Nr. / bus",
                    "SSN": "Rijksregisternr.",
                    "POSTALCODE": "Postcode",
                    "BIRTHDATE": "Geboortedatum",
                    "CITY": "Gemeente",
                    "PHONE": "Telefoon",
                    "EMAIL": "E-mail",
                    "LANGUAGE": "Taal"
                },
                "FAMILY_INFO": {
                    "HEADER": "Info partner & kinderen",
                    "FIRSTNAME": "Voornaam",
                    "LASTNAME": "Familienaam",
                    "PHONE": "Telefoon",
                    "EMAIL": "E-mail",
                    "CHILDREN": "Kinderen"
                },
                "REMARKS": {
                    "HEADER": "Opmerkingen",
                    "PLACEHOLDER": "Typ hier"
                }
            },
            "EDIT_ACCOUNTS": {
                "DIALOG": {
                    "TITLE": "Bankrekeningen",
                    "ACCOUNTS_MANAGED_BY": "Rekeningen beheerd door {{name}}",
                    "OFFICE_ACCOUNT_INFO": "Vul rekeningnummer in of selecteer een gekoppelde rekening",
                    "CLIENT_ACCOUNT_INFO": "\nVul rekeningnummer in",
                    "ADD_ACCOUNT": "Rekening toevoegen",
                    "LINKED": "Gekoppeld via cliëntenapp",
                    "NOT_LINKED": "Niet gekoppeld",
                    "TYPE": {
                        "LABEL": "Type"
                    },
                    "LABEL": {
                        "LABEL": "Label"
                    },
                    "IBAN": {
                        "LABEL": "IBAN",
                        "ERROR": {
                            "REQUIRED": "Vereist",
                            "INPUT_MASK": "Ongeldige IBAN",
                            "IBAN": "Ongeldige IBAN",
                            "LINKED": "Al gekoppeld aan {{param}}",
                            "DUPLICATE": "Dit IBAN werd al gebruikt"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                        "IBAN": "Ongeldige IBAN",
                        "LINKED": "IBAN al gekoppeld aan een andere cliënt",
                        "DUPLICATE": "Dit IBAN werd al gebruikt",
                        "ADD_ENABLED": "Voeg de rekening toe voor je kan bevestigen"
                    },
                    "ACCOUNT": {
                        "LABEL": "Rekening"
                    }
                }
            },
            "DOSSIER_INFO": {
                "GENERAL": {
                    "HEADER": "Algemeen",
                    "START_DATE": {
                        "LABEL": "Startdatum"
                    },
                    "END_DATE": {
                        "LABEL": "Einddatum"
                    },
                    "DOSSIER_NUMBER": {
                        "LABEL": "Dossiernummer"
                    },
                    "BALANCE_THRESHOLD": {
                        "LABEL": "Drempel voor “Saldo meer dan …” meldingen"
                    },
                    "HOMOLOGATION_DATE": {
                        "LABEL": "Datum vonnis homologatie"
                    },
                    "ADMISSIBILITY_DATE": {
                        "LABEL": "Datum beschikking van toelaatbaarheid"
                    },
                    "LABOUR_COURT": {
                        "LABEL": "Arbeidsrechtbank",
                        "DEFAULT": "Standaard arbeidsrechtbank"
                    },
                    "DOCKET_NUMBER": {
                        "LABEL": "Rolnummer"
                    },
                    "JUSTICE_PEACE": {
                        "LABEL": "Vredegerecht",
                        "DEFAULT": "Standaard vredegerecht"
                    },
                    "START_DATE_PLAN": {
                        "LABEL": "Startdatum plan"
                    },
                    "END_DATE_PLAN": {
                        "LABEL": "Einddatum plan"
                    },
                    "DEBT_MEDIATOR": {
                        "LABEL": "Schuldbemiddelaar",
                        "DEFAULT": "Standaard schuldbemiddelaar"
                    },
                    "ADMINISTRATOR": {
                        "LABEL": "Bewindvoerder",
                        "DEFAULT": "Standaard bewindvoerder"
                    },
                    "ASSIGNEE": {
                        "LABEL": "Dossierbeheerder",
                        "NONE": {
                            "LABEL": "Geen dossierbeheerder"
                        }
                    },
                    "START_DATE_REPORT": {
                        "LABEL": "Startdatum rapportage"
                    }
                },
                "EDIT": {
                    "LABEL": "Bewerken",
                    "DIALOG": {
                        "FIELD": {
                            "END_DATE": {
                                "ERROR": {
                                    "NOT_BEFORE_START_DATE": "Voor startdatum"
                                }
                            }
                        }
                    }
                },
                "FINANCIAL": {
                    "HEADER": "Financiële situatie",
                    "TOTAL_DEBT": {
                        "LABEL": "Totale schuld"
                    },
                    "MAIN_SUM": {
                        "LABEL": "Hoofdsom"
                    },
                    "INTEREST": {
                        "LABEL": "Interesten"
                    },
                    "COSTS": {
                        "LABEL": "Kosten"
                    },
                    "COURT_COSTS": {
                        "LABEL": "Gerechtskosten"
                    },
                    "INCREASES": {
                        "LABEL": "Verhogingen"
                    },
                    "MONTHLY_INCOME": {
                        "LABEL": "Inkomsten / m"
                    },
                    "MONTHLY_EXPENSES": {
                        "LABEL": "Uitgaven / m"
                    },
                    "DIFFERENCE": "Verschil"
                },
                "SETTLEMENT": {
                    "HEADER": "Aanzuiveringsregeling",
                    "TYPE": {
                        "LABEL": "Type",
                        "MONTHLY": "Maandelijkse reserve",
                        "PERCENTAGE": "Percentage",
                        "BALANCE": "Saldoregeling",
                        "MORATORIUM": "Moratorium",
                        "NONE": "Geen"
                    },
                    "MONTHLY": {
                        "LABEL": "Maandelijkse reserve"
                    },
                    "PERCENTAGE": {
                        "LABEL": "Percentage"
                    },
                    "PERIODICITY": {
                        "LABEL": "Periodiciteit betalingen (maanden)"
                    },
                    "START_DATE": {
                        "LABEL": "Startdatum betalingen"
                    },
                    "END_DATE": {
                        "LABEL": "Einddatum betalingen"
                    },
                    "RETAINED_AMOUNT": {
                        "LABEL": "Weerhouden"
                    },
                    "SUMMARY": {
                        "TITLE": "Samenvatting",
                        "COPY": {
                            "LABEL": "Kopiëren"
                        },
                        "REPAYMENT": {
                            "MONTHLY_OR_PERCENTAGE": "Terugbetaling van {{totalSumToPay}} ({{percentage}} van {{referenceAmount}}) over een periode van {{period}}.",
                            "BALANCE": "Terugbetaling van hoogstens {{referenceAmount}} voor zover middelen beschikbaar zijn over een periode van {{period}}.",
                            "MORATORIUM": "Alle uitvoeringsmaatregelen zijn geschorst."
                        },
                        "DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "Er wordt {{periodicity}} een dividend t.b.v. {{periodicAmountToPay}} pondspondsgewijs uitbetaald aan de schuldeisers.",
                            "BALANCE": "Er wordt {{periodicity}} een dividend pondspondsgewijs uitbetaald aan de schuldeisers indien middelen beschikbaar zijn."
                        },
                        "FIRST_DIVIDEND": {
                            "MONTHLY_OR_PERCENTAGE": "De eerste dividenden worden uitbetaald op {{paymentStartDate}}.",
                            "BALANCE": "De eerste dividenden worden potentieel uitbetaald op {{paymentStartDate}}."
                        },
                        "REFERENCE_AMOUNT": {
                            "TOTAL_DEBT": "de totale schuld",
                            "MAIN_SUM": "de hoofdsommen",
                            "RETAINED_AMOUNT": "de weerhouden bedragen"
                        },
                        "PERIOD": {
                            "YEARS": "{{years}} jaar",
                            "YEARS_MONTHS": "{{years}} jaar en {{months}} maanden"
                        },
                        "PERIODICITY": {
                            "YEARLY": "jaarlijks",
                            "MONTHLY": "elke {{months}} maand"
                        },
                        "NONE": "Er is nog geen aanzuiveringsregeling opgemaakt.",
                        "INCOMPLETE": "De aanzuiveringsregeling is onvolledig."
                    }
                },
                "CREDITORS": {
                    "HEADER": "Schuldeisers",
                    "COMPANY_NUMBER": {
                        "LABEL": "Ondernemingsnummer"
                    },
                    "ADDRESS": {
                        "LABEL": "Adres"
                    },
                    "PAYMENT_THIRD": {
                        "LABEL": "Art. 334 of afbetaling door derden"
                    },
                    "PAYMENTS": {
                        "TITLE": "Betalingsmodaliteiten",
                        "BUTTON": {
                            "LABEL": "Betalen"
                        },
                        "IBAN": {
                            "LABEL": "IBAN"
                        },
                        "REMITTANCE_INFO": {
                            "LABEL": "Mededeling"
                        },
                        "PERIODIC_AMOUNT": {
                            "LABEL": "Periodiek te betalen bedrag",
                            "TOOLTIP": "Berekend o.b.v. de modaliteiten van de aanzuiveringsregeling en de weerhouden bedragen van de schuldeisers."
                        },
                        "PLANNED_REPAYMENT": {
                            "LABEL": "Geplande terugbetaling"
                        }
                    },
                    "NAME": {
                        "LABEL": "Naam"
                    },
                    "ADD": {
                        "PLACEHOLDER": "Selecteer een schuldeiser",
                        "NEW_CREDITOR": "Nieuwe schuldeiser"
                    },
                    "SPLIT_COSTS": {
                        "LABEL": "Kosten opsplitsen"
                    },
                    "OVERRIDE_RETAINED_AMOUNTS": {
                        "LABEL": "Weerhouden bedragen overschrijven"
                    },
                    "TO_RETAIN": {
                        "LABEL": "te weerhouden"
                    },
                    "DATA": {
                        "TITLE": "Gegevens"
                    },
                    "DESCRIPTION": {
                        "LABEL": "Identificatie"
                    },
                    "REMARKS": {
                        "LABEL": "Opmerkingen"
                    }
                },
                "CREDITOR_PAYMENTS": {
                    "HEADER": "Aflossingstabel",
                    "COLUMNS": {
                        "POSITION": "Nr.",
                        "NAME": "Schuldeiser",
                        "RETAINED_AMOUNT": "Weerhouden",
                        "PAYMENT_THIRD_PARTIES": "Art. 334 of<br/>afbet. door derden",
                        "REMAINING_DEBT": "Saldo",
                        "DISTRIBUTION": "Pondsponds-<br/>gewijze verd."
                    },
                    "TOTAL": "Totaal"
                },
                "CREATE_DIVIDEND": {
                    "LABEL": "Dividend betalen",
                    "DIALOG": {
                        "TITLE": "Dividend betalen",
                        "ERROR": {
                            "IBAN": "Ongeldig IBAN",
                            "REMITTANCE_INFORMATION": "Ongeldige mededeling",
                            "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                            "MAT_DATEPICKER_MIN": "De uitvoeringsdatum mag niet in het verleden liggen",
                            "MAT_DATEPICKER_PARSE": "Ongeldige datum",
                            "MIN": "Het bedrag moet groter zijn dan 0"
                        }
                    },
                    "BANK_ACCOUNT": {
                        "LABEL": "Bankrekening",
                        "PLACEHOLDER": "Geen rekeningen beschikbaar"
                    },
                    "EXECUTION_DATE": {
                        "LABEL": "Datum"
                    },
                    "TOTAL_AMOUNT": {
                        "LABEL": "Totaalbedrag"
                    },
                    "CREDITORS": {
                        "TITLE": "Schuldeisers",
                        "EMPTY": "Geen schuldeisers",
                        "POSITION": {
                            "LABEL": "Nr."
                        },
                        "COUNTERPART_NAME": {
                            "LABEL": "Schuldeiser"
                        },
                        "COUNTERPART_REFERENCE": {
                            "LABEL": "Rekeningnummer"
                        },
                        "REMITTANCE_INFORMATION": {
                            "LABEL": "Mededeling"
                        },
                        "AMOUNT": {
                            "LABEL": "Bedrag"
                        }
                    }
                },
                "IMPORT_CREDITORS": {
                    "LABEL": "Importeren uit JustRestart",
                    "DIALOG": {
                        "TITLE": "Dossier: schuldeisers importeren (JustRestart)",
                        "COLUMNS": {
                            "POSITION": {
                                "LABEL": "Nr."
                            },
                            "NAME": {
                                "LABEL": "Schuldeiser"
                            },
                            "CAPITAL": {
                                "LABEL": "Kapitaal"
                            },
                            "INTEREST": {
                                "LABEL": "Interesten"
                            },
                            "NEGLIGENCE": {
                                "LABEL": "Nalatigheids-interesten"
                            },
                            "PENALTY": {
                                "LABEL": "Strafbeding"
                            },
                            "COSTS": {
                                "LABEL": "Kosten"
                            },
                            "TOTAL_DEBT": {
                                "LABEL": "Totale schuld"
                            },
                            "MAIN_SUM": {
                                "LABEL": "Hoofdsom"
                            },
                            "INCREASES": {
                                "LABEL": "Verhogingen"
                            },
                            "COURT_COSTS": {
                                "LABEL": "Gerechtskosten",
                                "LABEL_2": "Gerechts-kosten"
                            },
                            "FIELD": {
                                "LABEL": "corresponderend veld"
                            },
                            "TOTAL": {
                                "LABEL": "Totaal"
                            },
                            "TO_RETAIN": {
                                "LABEL": "te weerhouden"
                            },
                            "RETAINED_AMOUNT": {
                                "LABEL": "Weerhouden"
                            }
                        },
                        "IMPORT_DATA": {
                            "TITLE": "Te importeren data",
                            "FILLED_BY": {
                                "LABEL": "ingevuld door",
                                "CREDITORS": "Schuldeisers ({{columns}})",
                                "DEBT_MEDIATOR": "Schuldbemiddelaar ({{columns}})"
                            }
                        },
                        "CHECK": {
                            "TITLE": "Controle"
                        },
                        "ERROR": {
                            "NON_FINAL": " ",
                            "MIN": "Enkel positieve bedragen toegelaten"
                        },
                        "VALIDATION": {
                            "TITLE": "Validatie"
                        }
                    }
                },
                "MANUAL_CREDITORS": {
                    "LABEL": "Manueel invoeren"
                }
            },
            "CLIENT_NOTIFICATIONS": {
                "RESPOND_TO_DOCUMENT": {
                    "TITLE": "Betaalverzoek",
                    "NOTIFICATION": "Aanvraag om te betalen",
                    "RESPONSE": "Antwoord",
                    "MESSAGE": {
                        "TITLE": "Bericht aan de client (optioneel)",
                        "PLACEHOLDER": "Typ hier"
                    }
                }
            },
            "CLIENT_DOSSIER": {
                "EDIT": {
                    "DIALOG": {
                        "TITLE": "Dossier: {{ type }}",
                        "ERROR": {
                            "END_BEFORE_START": "Einddatum ligt voor startdatum",
                            "SUM": "De totale schuld is niet gelijk aan de som van de deelschulden",
                            "MIN": "De waarde is lager dan het minimum",
                            "MAX": "De waarde is hoger dan het maximum",
                            "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                            "IBAN": "Ongeldig IBAN",
                            "TOTAL_DEBT": "De totale schuld van het dossier is niet gelijk aan de som van de totale schulden per schuldeiser.",
                            "MAIN_SUM": "De hoofdsom van het dossier is niet gelijk aan de som van de hoofdsommen per schuldeiser.",
                            "INTEREST": "De interesten van het dossier zijn niet gelijk aan de som van de interesten per schuldeiser.",
                            "COSTS": "De kosten van het dossier zijn niet gelijk aan de som van de kosten per schuldeiser.",
                            "COURT_COSTS": "De gerechtskosten van het dossier zijn niet gelijk aan de som van de gerechtskosten per schuldeiser.",
                            "INCREASES": "De verhogingen van het dossier zijn niet gelijk aan de som van de verhogingen per schuldeiser.",
                            "RETAINED_AMOUNT": "Het weerhouden bedrag van het dossier is niet gelijk aan de som van de weerhouden bedragen per schuldeiser.",
                            "CREDITORS_UNIQUE": "Niet alle schuldeisers zijn uniek (zelfde combinatie naam, IBAN en mededeling).",
                            "REMITTANCE_INFORMATION": "Ongeldige mededeling",
                            "MAT_DATEPICKER_PARSE": "Ongeldige datum"
                        }
                    }
                }
            },
            "EDIT_DOSSIER": {
                "DIALOG": {
                    "ADD_CREDITOR": "Schuldeiser toevoegen"
                }
            },
            "CLIENT_DOCUMENTS": {
                "CREATE_RB_DOCUMENT": {
                    "DIALOG": {
                        "TITLE": "Nieuw document genereren",
                        "ERROR": {
                            "ACCOUNTS": "Geen rekening geselecteerd",
                            "REQUIRED": "Niet alle verplichte velden zijn ingevuld of geselecteerd",
                            "MAT_DATEPICKER_MAX": "De periode ligt niet in het toegestane bereik",
                            "MAT_DATEPICKER_MIN": "De periode ligt niet in het toegestane bereik",
                            "END_BEFORE_START": "Einddatum ligt voor startdatum"
                        }
                    },
                    "TYPE": {
                        "TITLE": "Type document",
                        "DISABLED": "Sommige types documenten kunnen niet gegenereerd worden. De cliënt is niet gelinkt aan de nodige bankrekeningen.",
                        "UNAVAILABLE": "Het is niet mogelijk om een document te genereren. De cliënt is niet gelinkt aan de nodige bankrekeningen."
                    },
                    "ACCOUNTS": {
                        "TITLE": "Bankrekeningen",
                        "NONE": "Voor dit documenttype hoeft geen selectie van rekeningen gemaakt te worden.",
                        "OFFICE": "het kantoor",
                        "CLIENT": "de cliënt",
                        "MANAGED_BY": "Beheerd door",
                        "BULK": "Er worden afzonderlijke documenten gegenereerd per geselecteerde rekening.",
                        "MULTIPLE": "Er wordt 1 document gegenereerd met daarin alle geselecteerde rekeningen."
                    },
                    "PERIOD": {
                        "TITLE": "Periode",
                        "CUSTOM": "Vrij",
                        "MONTHLY": "Maand",
                        "QUARTERLY": "Kwartaal",
                        "YEARLY": "Jaar",
                        "NONE": "Voor dit documenttype hoeft geen periode ingesteld te worden.",
                        "FROM": "Vanaf",
                        "UNTIL": "T.e.m.",
                        "COMPARE": "Vergelijking met vorige periode:"
                    },
                    "UNAVAILABLE": "Niet beschikbaar",
                    "HISTORY": {
                        "INCOMPLETE": "De historiek van 1 of meerdere rekeningen is onvolledig voor de geselecteerde periode"
                    }
                }
            },
            "BUDGET": {
                "CALCULATION_PERIOD": {
                    "LABEL": "Referentieperiode voor actuele bedragen",
                    "YEAR_1": "1 jaar",
                    "MONTH_1": "1 maand",
                    "MONTH_3": "3 maanden",
                    "MONTH_6": "6 maanden"
                },
                "EDIT": {
                    "LABEL": "Bewerken",
                    "DIALOG": {
                        "TITLE": "Budget"
                    },
                    "TABS": {
                        "INCOME": "Inkomsten",
                        "EXPENSES": "Uitgaven",
                        "REMARKS": "Opmerkingen"
                    },
                    "AUTOMATIC_ALLOWANCE": "Leefgeld automatisch berekenen",
                    "ACTUAL_PERIOD": "Referentieperiode voor actuele bedragen",
                    "RECEIVED_BY_CLIENT": "Ontvangst door cliënt",
                    "PAID_BY_CLIENT": "Betaling door cliënt",
                    "DETAILED": "Budget in detail",
                    "PERIOD": "Periode",
                    "USE_ACTUAL": "Actueel bedrag overnemen",
                    "REMARK": {
                        "PLACEHOLDER": "Opmerking"
                    },
                    "REMARKS": {
                        "PLACEHOLDER": "Opmerkingen"
                    }
                },
                "REMARKS": {
                    "HEADER": "Opmerkingen",
                    "COPY": "Kopiëren"
                },
                "MANAGED_BY_CLIENT": {
                    "HEADER": "Budgetplan cliënt"
                },
                "TABLE": {
                    "CATEGORY": "Categorie",
                    "PLAN": "Plan",
                    "ACTUAL": "Actueel",
                    "INCOME": "Inkomsten",
                    "EXPENSES": "Uitgaven",
                    "PROVISION": "Provisie onvoorziene kosten & extra's",
                    "TOTAL": "Totaal"
                },
                "PERIODICITY": {
                    "MONTHLY": {
                        "SHORT": "m"
                    },
                    "YEARLY": {
                        "SHORT": "j"
                    }
                },
                "MANAGED_BY_OFFICE": {
                    "DEBT_MEDIATION": {
                        "HEADER": "Budgetplan schuldbemiddelaar"
                    },
                    "FINANCIAL_MANAGEMENT": {
                        "HEADER": "Budgetplan bewindvoerder"
                    },
                    "BUDGET_GUIDANCE": {
                        "HEADER": "Budgetplan budgetbeheerder"
                    },
                    "RENT": {
                        "HEADER": "Budgetplan verhuurder"
                    },
                    "SOCIAL_RENT": {
                        "HEADER": "Budgetplan verhuurder"
                    },
                    "PCSW": {
                        "HEADER": "Budgetplan OCMW"
                    }
                },
                "UNPLANNED": {
                    "HEADER": "Niet in budgetplan"
                },
                "UNCATEGORIZED": {
                    "LABEL": "Zonder categorie"
                },
                "CLIENT_ONLY": {
                    "EDIT_HEADER": "Totaal budgetplan",
                    "VIEW_HEADER": "Budgetplan"
                }
            }
        },
        "CONTACTS": {
            "HEADER": {
                "LABEL": "Contacten"
            }
        },
        "DASHBOARD": {
            "HEADER": {
                "LABEL": "Dashboard"
            }
        },
        "MESSAGES": {
            "HEADER": {
                "LABEL": "Berichten"
            }
        },
        "NOTIFICATIONS": {
            "HEADER": {
                "LABEL": "Meldingen"
            },
            "FILTER": {
                "TYPE": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle meldingen"
                        },
                        "NOT_ENOUGH_FUNDS": {
                            "LABEL": "Saldo is te laag"
                        },
                        "BALANCE_EXCEEDED_THRESHOLD": {
                            "LABEL": "Saldo meer dan"
                        },
                        "INCOME_DETECTED": {
                            "LABEL": "Nieuwe inkomsten gedetecteerd"
                        },
                        "INSUFFICIENT_BALANCE_EXPECTED": {
                            "LABEL": "Ontoereikend saldo verwacht"
                        },
                        "UNEXPECTED_INCOME_LOSS": {
                            "LABEL": "Onverwacht verlies van inkomsten"
                        },
                        "RECURRING_EXPENSE_MISSING": {
                            "LABEL": "Verwachte betaling ontbreekt"
                        },
                        "NEW_RECURRING_EXPENSES": {
                            "LABEL": "Nieuwe schuld gedetecteerd"
                        },
                        "DOCUMENT_PAYMENT_REQUEST": {
                            "LABEL": "Aanvraag om te betalen"
                        },
                        "YEARLY_REPORT_DUE": {
                            "LABEL": "Jaarverslag moet ingediend worden"
                        },
                        "FINAL_REPORT_DUE": {
                            "LABEL": "Eindrapport moet ingediend worden"
                        }
                    }
                }
            },
            "TABLE": {
                "COLUMN": {
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Cliënt"
                        }
                    }
                }
            },
            "PROCESS_NOTIFICATIONS": {
                "DIALOG": {
                    "TITLE": "Meldingen afsluiten"
                },
                "ALL": "Ben je zeker dat je alle openstaande meldingen voor alle cliënten wilt afsluiten?",
                "TYPE": "Ben je zeker dat je alle openstaande meldingen van dit type voor alle cliënten wilt afsluiten?",
                "WARNING": "Deze actie kan enkel ongedaan gemaakt worden door de meldingen één voor één opnieuw te openen."
            }
        },
        "OFFICE": {
            "HEADER": {
                "LABEL": "Mijn kantoor"
            }
        },
        "PAYMENTS": {
            "HEADER": {
                "LABEL": "Betalingen"
            },
            "FILTER": {
                "STATUS": {
                    "OPTION": {
                        "ALL": {
                            "LABEL": "Alle betalingen"
                        },
                        "NOT_SUBMITTED": {
                            "LABEL": "In wachtrij"
                        },
                        "SUBMITTED": {
                            "LABEL": "Ingediend"
                        },
                        "NOT_PROCESSED": {
                            "LABEL": "Wordt gevalideerd"
                        },
                        "PROCESSED_WARNING": {
                            "LABEL": "Waarschuwing bij validatie"
                        },
                        "PROCESSED_ERROR": {
                            "LABEL": "Fout bij validatie"
                        },
                        "PROCESSED_OK": {
                            "LABEL": "Gevalideerd"
                        },
                        "PAID": {
                            "LABEL": "Betaald"
                        }
                    }
                }
            },
            "BUTTON": {
                "SUBMIT": {
                    "LABEL": "Wachtrij indienen"
                },
                "ADD": {
                    "LABEL": "Betaling toevoegen"
                },
                "SUBMIT_SELECTION": {
                    "LABEL": "Selectie indienen"
                },
                "REQUEUE": {
                    "LABEL": "Terug naar wachtrij"
                }
            },
            "TABLE": {
                "COLUMN": {
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Bedrag"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Cliënt"
                        }
                    },
                    "ACCOUNT": {
                        "HEADER": {
                            "LABEL": "Rekening"
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Begunstigde"
                        }
                    },
                    "REMITTANCE_INFO": {
                        "HEADER": {
                            "LABEL": "Mededeling"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Datum"
                        }
                    }
                },
                "EMPTY": "Geen betalingen gevonden"
            },
            "NOT_SUPPORTED": "Rekening ondersteunt geen betalingen (meer)",
            "PREPARE": {
                "SELECTED": "Geselecteerd: {{count}} van {{total}}",
                "NOT_VISIBLE": "{{count}} niet zichtbaar"
            },
            "DELETE": "Verwijderen",
            "EDIT": "Bewerken",
            "DELETE_PAYMENT": {
                "QUESTION": "Ben je zeker dat je deze betaling wilt verwijderen?",
                "DIALOG": {
                    "TITLE": "Betaling verwijderen"
                }
            },
            "REPEAT": "Herhalen",
            "DOWNLOAD_DOCUMENT": "Document downloaden",
            "REQUEST": {
                "KNOWN": "Ingediend",
                "UNKNOWN": "Wachtrij",
                "STATUS": {
                    "PROCESSING": {
                        "LABEL": "Wordt gevalideerd door Isabel 6"
                    },
                    "WARNING": {
                        "LABEL": "Waarschuwing in isabel 6"
                    },
                    "ERROR": {
                        "LABEL": "Foutmelding in isabel 6"
                    },
                    "VALIDATED": {
                        "LABEL": "Gevalideerd door Isabel 6"
                    },
                    "PARTIALLY_PAID": {
                        "LABEL": "Gedeeltelijk uitgevoerd"
                    },
                    "PAID": {
                        "LABEL": "Uitgevoerd"
                    }
                },
                "SUBMITTING": "Wordt ingediend"
            },
            "STATUS": {
                "NOT_SUBMITTED": {
                    "LABEL": "Betaling in wachtrij"
                },
                "PROCESSED_WARNING": {
                    "LABEL": "Waarschuwing bij validatie betaling door Isabel 6"
                },
                "PROCESSED_ERROR": {
                    "LABEL": "Foutmelding bij validatie betaling door Isabel 6"
                },
                "PROCESSED_OK": {
                    "LABEL": "Betaling gevalideerd door Isabel 6"
                },
                "PAID": {
                    "LABEL": "Betaling uitgevoerd"
                },
                "NOT_PROCESSED": {
                    "LABEL": "Wordt gevalideerd door Isabel 6"
                },
                "SUBMITTED": {
                    "LABEL": "Ingediend bij Isabel 6"
                },
                "SUBMITTING": {
                    "LABEL": "Wordt ingediend"
                }
            },
            "FILTERS": {
                "STATUS": {
                    "LABEL": "Status"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Zoeken"
                },
                "CLIENT": {
                    "LABEL": "Cliënt"
                },
                "COUNTERPART": {
                    "LABEL": "Begunstigde"
                },
                "DATE": {
                    "TITLE": "verwachte uitvoeringsdatum"
                }
            },
            "SUBMIT_PAYMENTS": {
                "DIALOG": {
                    "TITLE": "Betalingen indienen bij Isabel 6",
                    "OVERVIEW": {
                        "PAYMENTS": "betalingen",
                        "PAYMENT": "betaling"
                    },
                    "POSSIBLE_DUPLICATE_PAYMENTS": {
                        "TITLE": "Potentiële dubbels",
                        "DESCRIPTION": "Onderstaande betalingen staan dubbel in de wachtrij of werden recent al eens ingediend.",
                        "CLIENT": "Cliënt",
                        "ACCOUNT": "Rekening",
                        "COUNTERPART": "Begunstigde",
                        "REMITTANCE_INFORMATION": "Mededeling",
                        "QUEUED": "x in wachtrij",
                        "SUBMITTED_AT": "Ingediend op",
                        "EXECUTED_AT": "Uitgevoerd op",
                        "EMPTY": "Er werden geen gelijkaardige betalingen gevonden"
                    },
                    "INSUFFICIENT_BALANCES": {
                        "TITLE": "Ontoereikend saldo",
                        "DESCRIPTION": "Voor deze rekeningen is het saldo onvoldoende om alle betalingen te kunnen uitvoeren.",
                        "CLIENT": "Cliënt",
                        "ACCOUNT": "Rekening",
                        "IBAN": "IBAN",
                        "BALANCE": "Saldo",
                        "COUNTERPART": "Begunstigde",
                        "REMITTANCE_INFORMATION": "Mededeling",
                        "TOTAL": "TOTAAL",
                        "EMPTY": "Het saldo voor alle rekeningen is voldoende voor de betalingen"
                    },
                    "CONFIRM": {
                        "LABEL": "Betalingen indienen"
                    }
                }
            }
        },
        "PROFILE": {
            "HEADER": {
                "LABEL": "Mijn profiel"
            }
        },
        "BUTTON": {
            "CONFIRM": {
                "LABEL": "Bevestigen"
            },
            "CANCEL": {
                "LABEL": "Annuleren"
            },
            "EXPORT": {
                "LABEL": "Exporteren"
            },
            "ADD": {
                "LABEL": "Toevoegen"
            },
            "DELETE": {
                "LABEL": "Verwijderen"
            },
            "EDIT": {
                "LABEL": "Bewerken"
            },
            "CLOSE": {
                "LABEL": "Sluiten"
            },
            "NEXT": {
                "LABEL": "Volgende"
            },
            "PREVIOUS": {
                "LABEL": "Vorige"
            },
            "SKIP": {
                "LABEL": "Overslaan"
            },
            "PROCESS_NOTIFICATIONS": {
                "LABEL": "Meldingen afsluiten"
            },
            "OK": {
                "LABEL": "Oké"
            }
        },
        "BANK_ACCOUNT": {
            "AVAILABLE_BALANCE": {
                "LABEL": "Beschikbaar"
            },
            "SHARE_SETTINGS": {
                "OFFICE": "Zichtbaar voor cliënt:",
                "CLIENT": "Gedeeld met jou:",
                "BALANCE": "Saldo",
                "TRANSACTIONS": "Verrichtingen",
                "INCOMING_TRANSACTIONS": "Inkomende verrichtingen",
                "OUTGOING_TRANSACTIONS": "Uitgaande verrichtingen",
                "SHARED_BY": "Gedeeld door",
                "SHARED_BY_UNKNOWN": "Voormalige gebruiker"
            },
            "NO_LINKED_CLIENT": "Koppel deze rekening aan een nieuwe of bestaande<br/>cliënt om het saldo en de verrichtingen te bekijken.",
            "LATEST_SYNC": "Gesynchroniseerd",
            "BUTTON": {
                "LINK_CLIENT": {
                    "LABEL": "Cliënt koppelen"
                },
                "CREATE_CLIENT": {
                    "LABEL": "Cliënt aanmaken"
                },
                "AUTHORIZE": {
                    "LABEL": "Autorisatie vernieuwen"
                },
                "PAYMENT": {
                    "LABEL": "Nieuwe betaling"
                },
                "IMPORT": {
                    "LABEL": "Historiek importeren"
                },
                "SELECT": {
                    "LABEL": "Selecteren"
                }
            },
            "WARNING": {
                "AUTH_INVALID": "De autorisatie voor deze rekening is niet meer geldig.<br/>Om het synchroniseren te hervatten, moet de autorisatie vernieuwd worden.",
                "EXPIRING": "De autorisatie voor deze rekening vervalt op {{ date }}.<br/>Om een onderbreking van de synchronisatie te voorkomen, moet de autorisatie tijdig vernieuwd worden.",
                "TECHNICAL_FAILURE": "Technisch probleem<br/>Door een technisch probleem bij {{ bank }} is synchronisatie tijdelijk niet mogelijk.",
                "ARCHIVED": "Deze rekening werd gearchiveerd op {{ date }}",
                "MOVED_TO_ISABEL_ACTIVE": "De koppeling met {{ bank }} is gemigreerd naar Isabel 6.<br/>Het synchroniseren zal eindigen op {{ date }}, tenzij deze rekening tegen dan via Isabel Connect kan opgehaald worden.",
                "MOVED_TO_ISABEL_INACTIVE": "De koppeling met {{ bank }} is gemigreerd naar Isabel 6.<br/>Het synchroniseren zal hervat worden zodra deze rekening via Isabel Connect kan opgehaald worden.",
                "NOT_FOUND_IN_ISABEL": "Deze rekening is niet meer beschikbaar via Isabel Connect.<br/>Het synchroniseren zal hervat worden zodra deze rekening opnieuw via Isabel Connect kan opgehaald worden.",
                "BLOCKED": "Deze rekening werd toegevoegd door een inmiddels geblokkeerde gebruiker van de cliëntenapp.<br/>Er wordt geen synchronisatie meer uitgevoerd."
            },
            "TABLE": {
                "COLUMN": {
                    "CATEGORY": {
                        "HEADER": {
                            "LABEL": "Categorie"
                        },
                        "CREDITOR": "Schuldeiser",
                        "INTRADAY": {
                            "LABEL": "Intraday verrichting",
                            "INFO": "Intraday verrichtingen kunnen nog niet gewijzigd worden omdat ze nog niet definitief zijn"
                        }
                    },
                    "COUNTERPART": {
                        "HEADER": {
                            "LABEL": "Tegenpartij"
                        }
                    },
                    "DETAILS": {
                        "HEADER": {
                            "LABEL": "Details"
                        },
                        "REMITTANCE_INFO": "Mededeling",
                        "COUNTERPART": {
                            "FROM": "Van",
                            "TO": "Naar"
                        },
                        "VALUE_DATE": "Valutadatum",
                        "INTERNAL_NOTE": "Interne notitie"
                    },
                    "AMOUNT": {
                        "HEADER": {
                            "LABEL": "Bedrag"
                        }
                    },
                    "TAGS": {
                        "HEADER": {
                            "LABEL": "Tags"
                        }
                    }
                },
                "EMPTY": "Geen verrichtingen gevonden",
                "ACTIONS": {
                    "REPEAT": "Opnieuw betalen",
                    "DOWNLOAD": "Document downloaden",
                    "UPLOAD_DOCUMENT": "Document opladen"
                },
                "NOTIFICATIONS_ONLY": "Voor deze rekening worden enkel meldingen gedeeld."
            },
            "FILTERS": {
                "CATEGORY": {
                    "TITLE": "Categorie",
                    "UNCATEGORIZED": "Geen categorie",
                    "MULTIPLE": "Meerdere categorieën"
                },
                "DATE": {
                    "TITLE": "Uitvoeringsdatum"
                },
                "COUNTERPART": {
                    "VALUE": {
                        "NAME": "Naam bevat \"{{counterpart}}\"",
                        "REFERENCE": "IBAN bevat \"{{counterpart}}\""
                    },
                    "TITLE": "Tegenpartij",
                    "NAME": "Naam bevat",
                    "REFERENCE": "IBAN bevat"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Mededeling",
                    "CONTAINS": "Mededeling bevat",
                    "VALUE": "Mededeling bevat \"{{remittanceInfo}}\""
                },
                "TYPE": {
                    "TITLE": "Type",
                    "CONTAINS": "Type bevat",
                    "VALUE": "Type bevat \"{{description}}\""
                },
                "AMOUNT": {
                    "TITLE": "Bedrag",
                    "MIN": "Minimum",
                    "MAX": "Maximum",
                    "VALUE": {
                        "MIN": "≥ {{amountMin}}",
                        "BETWEEN": "{{amountMin}} – {{amountMax}}",
                        "MAX": "≤ {{amountMax}}"
                    },
                    "ALL": "Inkomend & uitgaand",
                    "DEBIT": "Uitgaand",
                    "CREDIT": "Inkomend"
                },
                "TAGS": {
                    "MULTIPLE": "Meerdere tags",
                    "TITLE": "Tags"
                },
                "SEARCH_QUERY": {
                    "PLACEHOLDER": "Zoeken"
                }
            },
            "EDIT_CLIENT_SETTINGS": {
                "TITLE": "Cliëntinstellingen",
                "LINKED_CLIENT": {
                    "HEADER": "Gekoppelde cliënt"
                },
                "TYPE": {
                    "HEADER": "Type rekening"
                },
                "SELECT_CLIENT": "Selecteer een cliënt",
                "NO_CLIENT": "Geen"
            },
            "EDIT_TRANSACTION_CATEGORY": {
                "TITLE": "Categorie",
                "APPLY_TO": "Toepassen op",
                "TRANSACTION": {
                    "TO": "Naar",
                    "REMITTANCE_INFO": "Mededeling"
                },
                "CREDITOR": "Schuldeiser",
                "TYPES": {
                    "INCOMING": {
                        "TRANSACTION": "Enkel deze verrichting",
                        "ACCOUNT": "Alle inkomsten van <u>deze rekening</u> die voldoen aan",
                        "CLIENT": "Alle inkomsten van <u>deze cliënt</u> die voldoen aan",
                        "ALL_CLIENTS": "Alle inkomsten van <u>alle cliënten</u> die voldoen aan"
                    },
                    "OUTGOING": {
                        "TRANSACTION": "Enkel deze verrichting",
                        "ACCOUNT": "Alle uitgaven van <u>deze rekening</u> die voldoen aan",
                        "CLIENT": "Alle uitgaven van <u>deze cliënt</u> die voldoen aan",
                        "ALL_CLIENTS": "Alle uitgaven van <u>alle cliënten</u> die voldoen aan"
                    }
                },
                "FILTERS": {
                    "COUNTERPART_REFERENCE": "Referentie tegenpartij is",
                    "COUNTERPART_NAME": "Tegenpartij bevat",
                    "REMITTANCE_INFO": "Mededeling bevat",
                    "DATE_FROM": "Datum is ten vroegste",
                    "DATE_TO": "Datum is ten laatste",
                    "AMOUNT_MIN": "Bedrag is minimaal",
                    "AMOUNT_MAX": "Bedrag is maximaal",
                    "DESCRIPTION": "Type bevat",
                    "CATEGORY": "Categorie is"
                },
                "ADD_CATEGORY": "Nieuwe categorie",
                "MAIN_CATEGORY": "Hoofdcategorie",
                "NEW_SUB_CATEGORY": {
                    "TITLE": "Nieuwe subcategorie",
                    "ERROR": {
                        "REQUIRED": "Vereist",
                        "DUPLICATE": "al toegevoegd"
                    }
                },
                "CATEGORY": {
                    "ERROR": {
                        "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                        "DUPLICATE": "Categorie werd al toegevoegd",
                        "MIN": "Enkel positieve getallen toegelaten",
                        "FILTER_REQUIRED": "Selecteer minstens één filter"
                    },
                    "SELECT": "Selecteer een categorie"
                },
                "ADD_CATEGORY_NOTICE": "Eigen categorieën zijn beschikbaar voor alle cliënten."
            },
            "EDIT_TRANSACTION_DETAILS": {
                "TRANSACTION": {
                    "TITLE": "Verrichting"
                }
            },
            "SET_ARCHIVED_STATUS": {
                "DIALOG": {
                    "STATUS": {
                        "TITLE": "Status",
                        "ARCHIVED": "Gearchiveerd op {{ date }}",
                        "ACTIVE": "Actief"
                    },
                    "TITLE": "Archiveren",
                    "ACTION": {
                        "TITLE": "Actie",
                        "ARCHIVED": "Herstellen",
                        "ACTIVE": "Archiveren"
                    },
                    "INFO": {
                        "ARCHIVED": "Het herstellen van een bankrekening houdt in:\n<ul>\n<li>De rekening wordt opnieuw getoond in de lijst van actieve rekeningen.</li>\n<li>De rekening kan terug gekoppeld worden aan een (andere) cliënt.</li>\n<li>Het is weer mogelijk de categorie en tags van een verrichting aan te passen.</li>\n<li>Als de rekening beschikbaar is via Isabel Connect, zal de synchronisatie automatisch hervatten.</li>\n<li>Als de rekening rechtstreeks via de bank werd toegevoegd, dient de autorisatie vernieuwd te worden.</li>\n<li><b>LET OP: Als de rekening lange tijd gearchiveerd is geweest, kan het zijn dat de historiek niet volledig kan aangevuld worden!</b></li>\n</ul>",
                        "ACTIVE": "Het archiveren van een bankrekening houdt in:\n<ul>\n<li>De rekening wordt niet meer getoond in de lijst van actieve rekeningen.</li>\n<li>De rekening kan niet langer gekoppeld worden aan een cliënt.</li>\n<li>Als de rekening al gekoppeld is aan een cliënt, blijft de rekening zichtbaar bij die cliënt.</li>\n<li>De categorie en tags van een verrichting kunnen niet meer aangepast worden.</li>\n<li>Verrichtingen worden niet langer gesynchroniseerd en het saldo is niet meer beschikbaar.</li>\n</ul>",
                        "NOT_RESTORABLE": "Deze rekening kan niet hersteld worden:\n<ul>\n<li>De rekening is gekoppeld aan een gearchiveerde cliënt.</li>\n<li>Om de rekening te herstellen, dient eerst de gekoppelde cliënt hersteld te worden.</li>\n</ul>"
                    }
                }
            },
            "EDIT_TRANSACTION_TAGS": {
                "TITLE": "Tags",
                "ADD_TAG_NOTICE": "Tags zijn beschikbaar voor elke cliënt afzonderlijk",
                "NEW_TAG": "Nieuwe tag",
                "ERROR": {
                    "DUPLICATE": "al toegevoegd",
                    "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                    "MIN": "Enkel positieve getallen toegelaten",
                    "FILTER_REQUIRED": "Selecteer minstens één filter"
                }
            },
            "SELECTED": {
                "SINGULAR": "1 verrichting geselecteerd",
                "PLURAL": "{{count}} verrichtingen geselecteerd",
                "SUM": {
                    "BALANCE": "totaal",
                    "INCOME": "inkomend",
                    "EXPENSES": "uitgaand"
                }
            }
        },
        "FILTER": {
            "TITLE": "Filter op",
            "SET": "Instellen"
        },
        "FILTERS": {
            "DATE": {
                "TITLE_SHORT": "Datum",
                "FROM": "Vanaf",
                "TO": "Tot en met",
                "VALUE": {
                    "FROM": "Vanaf {{dateFrom}}",
                    "TO": "Tot en met {{dateTo}}",
                    "FROM_TO": "{{dateFrom}} – {{dateTo}}"
                }
            }
        },
        "TABLE": {
            "COLLAPSE_ALL": "Alles dichtklappen",
            "EXPAND_ALL": "Alles openklappen"
        },
        "DOCUMENTS": {
            "TABLE": {
                "COLUMN": {
                    "DOCUMENT": {
                        "HEADER": {
                            "LABEL": "Document"
                        }
                    },
                    "DATE": {
                        "HEADER": {
                            "LABEL": "Datum"
                        }
                    },
                    "CLIENT": {
                        "HEADER": {
                            "LABEL": "Cliënt"
                        }
                    }
                },
                "EMPTY": "Geen documenten gevonden"
            },
            "TYPE": {
                "DOCUMENT": "Document",
                "IMAGE": "Afbeelding",
                "FINANCIAL_REPORT": "Financieel rapport",
                "YEARLY_DEBT_REPORT": "Jaarverslag CSR",
                "FINAL_DEBT_REPORT": "Eindverslag CSR",
                "YEARLY_REPORT_XLSX_GUARDIANSHIP": "Rapportering bewind",
                "YEARLY_OVERSIGHT_REPORT": "Rekeninguittreksel",
                "ARCHIVE": "Archief",
                "HONORARIUM_GUARDIANSHIP": "Vergoeding en uitzonderlijke kosten",
                "ACTIVE_DOSSIERS_DEBT_REPORT": "Overzicht lopende dossiers CSR",
                "EMAIL": "E-mail",
                "YEARLY_OVERSIGHT_REPORT_WITH_DOCUMENTS": "Rekeninguittreksel met bijlagen",
                "HONORARIUM_DEBT_MEDIATION": "Ereloon CSR"
            },
            "GENERATED_BY": "Gegenereerd door",
            "ADDED_BY": "Geüpload door",
            "SYSTEM_USER": "ROOV",
            "SHARED_WITH_CLIENT": "Gedeeld met de cliënt",
            "HIDDEN": "Verborgen",
            "FILTER": {
                "SHOW_HIDDEN": {
                    "LABEL": "Verborgen documenten"
                }
            },
            "FILTERS": {
                "TYPE": {
                    "MULTIPLE": "Meerdere types",
                    "LABEL": "Type"
                },
                "OWNER": {
                    "LABEL": "Eigenaar",
                    "MULTIPLE": "Meerdere eigenaars"
                },
                "CLIENT": {
                    "LABEL": "Cliënt"
                }
            },
            "BUTTON": {
                "GENERATE": {
                    "LABEL": "Genereren"
                },
                "UPLOAD": {
                    "LABEL": "Opladen"
                },
                "PROCESS_ALL": {
                    "LABEL": "Alles verwerken"
                },
                "SELECT": {
                    "LABEL": "Selecteren"
                },
                "SELECT_ALL": {
                    "LABEL": "Alles selecteren"
                },
                "PAY": {
                    "LABEL": "Betalen"
                },
                "ASSIGN": {
                    "LABEL": "Toewijzen"
                },
                "DELETE": {
                    "LABEL": "Verwijderen"
                },
                "MOVE": {
                    "LABEL": "Verplaatsen"
                },
                "EMAIL": {
                    "LABEL": "Toevoegen via e-mail"
                }
            },
            "DROP": "Drop je documenten hier",
            "EXTENSIONS": "Aanvaarde bestandstypes",
            "UPLOAD_LIMITS": "Maximaal 20MB per bestand en 200MB in totaal.",
            "RENAME": "Hernoemen",
            "DELETE": "Verwijderen",
            "HIDE": "Verbergen",
            "MAKE_VISIBLE": "Zichtbaar maken",
            "SHARE": "Delen",
            "STOP_SHARING": "Stoppen met delen",
            "CREATE_PAYMENT": "Betalen",
            "EDIT_PAYMENT": "Betaling bewerken",
            "REPEAT_PAYMENT": "Opnieuw betalen",
            "HEADER": {
                "LABEL": "Documenten"
            },
            "ACTIVE_DEBT_DOSSIERS_REPORT": {
                "CREATE_SOON": "Genereer hier vanaf 1 juli het overzicht met stand van zaken op 30/06 van lopende dossiers CSR.",
                "CREATE_NOW": "Genereer nu het overzicht met stand van zaken op 30/06 van lopende dossiers CSR.",
                "BUTTON": {
                    "LABEL": "Genereren"
                },
                "LABOUR_COURT": {
                    "PLACEHOLDER": "Selecteer een arbeidsrechtbank"
                }
            },
            "UNPROCESSED": "Te verwerken",
            "PROCESSED": "Verwerkt",
            "ASSIGN": "Toewijzen",
            "SELECTED": {
                "SINGULAR": "1 document geselecteerd",
                "PLURAL": "{{count}} documenten geselecteerd"
            },
            "MOVE": "Verplaatsen",
            "ADDED_BY_EMAIL": "Toegevoegd via e-mail van",
            "ADDED_BY_EMAIL_OWNER": "Toegevoegd via e-mail door",
            "EMAIL": {
                "DIALOG": {
                    "TITLE": "Documenten toevoegen via e-mail",
                    "FIRST_LINE": "Voeg documenten toe door ze als bijlage te e-mailen naar:",
                    "ADDITIONAL_INFO": "Ondersteunde documenten die naar dit adres gestuurd worden als bijlage, zullen aan de te verwerken documenten toegevoegd worden.",
                    "BUTTON": {
                        "COPY": {
                            "LABEL": "Adres kopiëren"
                        }
                    }
                }
            },
            "DOWNLOAD": "Downloaden",
            "SHARED_BY_CLIENT": "Gedeeld vanuit de cliëntenapp"
        },
        "ADD_PAYMENT_DIALOG": {
            "TITLE": "Nieuwe betaling",
            "FROM": {
                "HEADER": "Van",
                "CLIENT": {
                    "TITLE": "Cliënt",
                    "NO_CLIENT": "Selecteer een cliënt"
                },
                "ACCOUNT": {
                    "TITLE": "Rekening",
                    "NO_ACCOUNT": "Selecteer een rekening"
                }
            },
            "TO": {
                "HEADER": "Naar",
                "BENEFICIARY": {
                    "TITLE": "Begunstigde",
                    "NO_BENEFICIARY": "Selecteer een begunstigde",
                    "NO_EDIT_CREDITOR": "Schuldeiser gelinkt aan de cliënt. Kan hier niet gewijzigd worden.",
                    "NO_EDIT_BANK_ACCOUNT": "Rekening gekoppeld aan de cliënt. Kan hier niet gewijzigd worden.",
                    "NAME": "Naam",
                    "IBAN": "IBAN",
                    "SINGLE_USE": "Eénmalig gebruik",
                    "CLIENT": "Bewaren voor cliënt",
                    "GLOBAL": "Globaal bewaren",
                    "ADD_BENEFICIARY": "Nieuwe begunstigde"
                }
            },
            "DATA": {
                "HEADER": "Gegevens",
                "AMOUNT": {
                    "TITLE": "Bedrag"
                },
                "REMITTANCE_INFO": {
                    "TITLE": "Mededeling"
                },
                "EXECUTION_DATE": {
                    "TITLE": "Uitvoeringsdatum"
                }
            },
            "ERROR": {
                "REMITTANCE_INFORMATION": "Ongeldige mededeling",
                "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                "MAT_DATEPICKER_MIN": "De uitvoeringsdatum mag niet in het verleden liggen",
                "MAT_DATEPICKER_PARSE": "Ongeldige datum",
                "MIN": "Het bedrag moet groter zijn dan 0",
                "EDITING": "Begunstigde moet eerst bewaard worden",
                "IBAN": "Ongeldig IBAN",
                "UNIQUE": "Er bestaat al een rekening met dit IBAN",
                "BENEFICIARY_NAME": "Ongeldige naam",
                "SAME_IBAN": "Rekeningnummer begunstigde is gelijk aan dat van de betaalrekening",
                "MAT_DATEPICKER_MAX": "De uitvoeringsdatum mag niet meer dan een jaar in de toekomst liggen",
                "DOCUMENT_NAME_EDITING": "Naam moet eerst bewaard worden"
            },
            "ANOTHER_PAYMENT": "Nog een betaling toevoegen",
            "WARNING": {
                "DUPLICATE_PAYMENT_EXECUTED": "Een gelijkaardige betaling werd al uitgevoerd op {{date}}",
                "DUPLICATE_PAYMENT_SUBMITTED": "Een gelijkaardige betaling werd al ingediend op {{date}}",
                "DUPLICATE_PAYMENT_QUEUED": "Een gelijkaardige betaling staat al in de wachtrij"
            },
            "ANOTHER_PAYMENT_DESCRIPTION": "Geselecteerde velden worden overgenomen.",
            "INTERNAL_NOTE": {
                "TITLE": "Interne notitie",
                "DESCRIPTION": "Enkel beschikbaar in ROOV Business.",
                "PLACEHOLDER": "Interne notitie"
            }
        },
        "DOCUMENT": {
            "RENAME_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Document hernoemen",
                    "ERROR": {
                        "REQUIRED": "Vul een naam in"
                    }
                },
                "NAME": {
                    "LABEL": "Naam",
                    "PLACEHOLDER": "Naam zonder bestandsextensie"
                }
            },
            "DELETE_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Document verwijderen",
                    "QUESTION_SINGLE": "Ben je zeker dat je dit document wilt verwijderen?",
                    "INFO_SINGLE": "Als het document gedeeld is, wordt het ook verwijderd voor de cliënt. Deze actie kan niet ongedaan gemaakt worden.",
                    "TITLE_MULTI": "Documenten verwijderen",
                    "QUESTION_MULTI": "Ben je zeker dat je deze documenten wilt verwijderen?",
                    "INFO_MULTI": "Als een document gedeeld is, wordt het ook verwijderd voor de cliënt. Deze actie kan niet ongedaan gemaakt worden."
                }
            },
            "ASSIGN_DOCUMENT": {
                "DIALOG": {
                    "TITLE_SINGLE": "Document toewijzen aan een cliënt",
                    "ASSIGN_TO": "Toewijzen aan",
                    "ERROR": {
                        "REQUIRED": "Selecteer een cliënt",
                        "DOCUMENT_NAME_EDITING": "Naam moet eerst bewaard worden"
                    },
                    "TITLE_MULTI": "Documenten toewijzen aan een cliënt",
                    "SELECTED_DOCUMENTS": "Geselecteerde documenten"
                }
            },
            "VIEW_DOCUMENT": {
                "DIALOG": {
                    "TITLE": "Document"
                }
            }
        },
        "CLIENT": {
            "CLIENT_APP": {
                "STATUS": {
                    "NOT_SENT": "Verstuur een uitnodiging per e-mail of geef de persoonlijke code door.",
                    "SENT": "Een uitnodiging werd per e-mail verstuurd op {{date}}.",
                    "CLAIMED": "De koppeling met het mobiel account werd gemaakt op {{date}}.",
                    "REVOKED": "De koppeling met het mobiel account werd verbroken op {{date}}."
                },
                "CODE": {
                    "TITLE": "Persoonlijke code",
                    "MESSAGE": "Door deze code in te vullen in de mobiele ROOV app wordt het mobiel account gekoppeld aan deze cliënt."
                },
                "INFO": {
                    "TITLE": "Via de mobiele app van ROOV kan informatie uitgewisseld worden tussen jou en de cliënt.",
                    "FEATURE_1": "Jij krijgt inzage op de rekening(en) die de cliënt toevoegt. De cliënt kiest per rekening of het saldo en/of de verrichtingen gedeeld worden. Wanneer er (mogelijke) problemen opduiken, ontvang je een melding.",
                    "FEATURE_2": "De cliënt krijgt inzage op de rekening(en) die jij voor hen beheert. Je kan per rekening instellen welke informatie gedeeld wordt.",
                    "FEATURE_3": "Je kan documenten delen met de cliënt en vice versa.",
                    "FEATURE_4": "De cliënt kan een verzoek indienen om een factuur te betalen vanop een rekening die door jou beheerd wordt.",
                    "ACCESS": {
                        "TITLE": "Jij bepaalt of je toegang geeft tot dit dossier.",
                        "DESCRIPTION": "Nodig een gebruiker uit via e-mailadres of GSM-nummer. Je kan de gebruiker nadien blokkeren om de toegang terug in te trekken en eventueel een andere gebruiker uit te nodigen."
                    },
                    "CLIENT_ACCOUNTS": {
                        "TITLE": "Jij kan inzage krijgen op de rekening(en) die de gebruiker toevoegt.",
                        "DESCRIPTION": "De gebruiker kiest per rekening welke informatie gedeeld wordt en of jij meldingen mag ontvangen wanneer er (mogelijke) problemen opduiken."
                    },
                    "OFFICE_ACCOUNTS": {
                        "TITLE": "De gebruiker kan inzage krijgen op de rekening(en) die jij voor dit dossier beheert.",
                        "DESCRIPTION": "Je kan per rekening instellen welke informatie gedeeld wordt."
                    },
                    "DOCUMENTS": {
                        "TITLE": "Je kan documenten delen met de gebruiker; en vice versa.",
                        "OWN_DESCRIPTION": "Je herkent documenten die jij deelt aan dit icoontje:",
                        "CLIENT_DESCRIPTION": "Documenten die met jou gedeeld worden herken je dan weer aan dit icoontje:"
                    },
                    "PAYMENT_REQUESTS": {
                        "TITLE": "De gebruiker kan een verzoek indienen om een factuur te betalen vanop een rekening die door jou beheerd wordt.",
                        "DOCUMENT_DESCRIPTION": "De factuur verschijnt als gedeeld document in de lijst.",
                        "NOTIFICATION_DESCRIPTION": "Je ontvangt ook een melding van waaruit je het verzoek kan aanvaarden of weigeren en van waaruit je de betaling kan aanmaken."
                    }
                },
                "ARCHIVED": "Een koppeling met een mobiel account is enkel mogelijk voor actieve cliënten.",
                "SEND_INVITATION": {
                    "EMAIL": "E-mail cliënt",
                    "SEND_COPY": "bezorg een kopie aan mezelf",
                    "SEND": "Uitnodiging versturen",
                    "SEND_AGAIN": "Uitnodiging opnieuw versturen"
                },
                "MOBILE_USER": {
                    "ACTIVE_USER": "Actieve gebruiker",
                    "LOGIN_METHOD": "Login methode",
                    "EMAIL": "E-mail",
                    "PHONE": "GSM-nummer",
                    "INVITE": {
                        "LABEL": "Gebruiker uitnodigen",
                        "LOADING": "Gebruikers worden geladen",
                        "ERROR": "Gebruikers konden niet worden geladen",
                        "ACTIVE_USER": "Er is al een actieve gebruiker"
                    }
                },
                "MOBILE_USER_INVITATION_DIALOG": {
                    "TITLE": "Gebruiker uitnodigen voor de mobiele app",
                    "PERSONAL_INFO": "Persoonsgegevens",
                    "LOGIN_INFO": "Logingegevens",
                    "FIRST_NAME": "Voornaam",
                    "LAST_NAME": "Familienaam",
                    "EMAIL": "E-mailadres",
                    "PHONE": "GSM-nummer",
                    "NO_EMAIL_ACCESS": "Deze gebruiker heeft geen toegang tot e-mail.",
                    "NO_EMAIL_ACCESS_INFO": "Indien de gebruiker geen toegang heeft tot e-mail op de smartphone, is het mogelijk om in te loggen via SMS.",
                    "ERROR": {
                        "REQUIRED": "Controleer verplichte velden",
                        "EMAIL": "Ongeldig e-mailadres",
                        "PATTERN": "Ongeldig GSM-nummer",
                        "DUPLICATE": "Gebruiker bestaat al"
                    },
                    "COUNTRY_CODE": "Landcode",
                    "PHONE_NUMBER": "GSM-nummer",
                    "COUNTRY": {
                        "BELGIUM": "België",
                        "NETHERLANDS": "Nederland",
                        "FRANCE": "Frankrijk",
                        "GERMANY": "Duitsland",
                        "LUXEMBOURG": "Luxemburg"
                    }
                }
            }
        },
        "SETTINGS": {
            "HEADER": {
                "LABEL": "Instellingen"
            },
            "TAB": {
                "ACCOUNT": {
                    "LABEL": "Mijn account",
                    "INFO": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                                    "EMAIL": "Ongeldig e-mailadres"
                                }
                            }
                        }
                    },
                    "PASSWORD": {
                        "EDIT": {
                            "DIALOG": {
                                "ERROR": {
                                    "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                                    "DIFFERENT": "Wachtwoorden zijn verschillend",
                                    "MINLENGTH": "Minimaal 8 tekens"
                                }
                            }
                        }
                    }
                },
                "OFFICE": {
                    "LABEL": "Mijn kantoor",
                    "EDIT": {
                        "DIALOG": {
                            "ERROR": {
                                "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                                "IBAN": "Ongeldige IBAN",
                                "COMPANY_NUMBER": "Ongeldig ondernemingsnummer"
                            }
                        }
                    }
                },
                "USERS": {
                    "LABEL": "Gebruikers"
                },
                "ISABEL_CONNECT": {
                    "LABEL": "Isabel Connect",
                    "CONNECTED": "Isabel Connect is actief",
                    "INFO": {
                        "TITLE": "Via Isabel Connect leg je een verbinding tussen ROOV Business en Isabel 6.",
                        "FEATURE_1": "Om Isabel Connect te gebruiken is slechts een éénmalige setup nodig.",
                        "FEATURE_2": "Alle rekening uit je Isabel 6 account zijn automatisch beschikbaar in ROOV Business.",
                        "FEATURE_3": "Je kan vanuit ROOV Business betalingen klaarzetten in Isabel 6."
                    },
                    "CONNECT": "Isabel Connect instellen"
                },
                "CATEGORIES": {
                    "LABEL": "Categorieën"
                }
            },
            "ACCOUNT": {
                "PERSONAL_INFO": {
                    "HEADER": "Persoonsgegevens",
                    "FIRSTNAME": "Voornaam",
                    "LASTNAME": "Familienaam",
                    "EMAIL": "E-mail"
                },
                "PASSWORD": {
                    "HEADER": "Wachtwoord",
                    "INFO": "Aanmelden bij ROOV Business doe je met je e-mailadres en een wachtwoord",
                    "EDIT": {
                        "TITLE": "Wachtwoord wijzigen"
                    },
                    "OLD_PASSWORD": {
                        "HEADER": "Geef je huidig wachtwoord in om een nieuw in te stellen",
                        "LABEL": "Huidig wachtwoord"
                    },
                    "NEW_PASSWORD": {
                        "HEADER": "Kies een nieuw wachtwoord",
                        "LABEL": "Nieuw wachtwoord",
                        "CONFIRM_PASSWORD": "Herhaal wachtwoord"
                    }
                }
            },
            "OFFICE": {
                "GENERAL": {
                    "HEADER": "Algemeen",
                    "NAME": "Naam kantoor",
                    "LANGUAGE": "Taal",
                    "ADDRESS": {
                        "STREET": "Straat",
                        "NUMBER": "Nr. / bus",
                        "POSTAL_CODE": "Postcode",
                        "CITY": "Gemeente"
                    },
                    "COMPANY_NUMBER": "Ondernemingsnummer"
                },
                "BANK_ACCOUNTS": {
                    "HEADER": "Bankrekeningen",
                    "PREFIX": "Dit helpt om verrichtingen tussen de cliënt en jou te herkennen en automatisch aan de juiste categorie toe te wijzen.",
                    "IBAN": "IBAN",
                    "ADD_ACCOUNT": "Rekening toevoegen"
                },
                "COURTS": {
                    "HEADER": "Rechtbanken",
                    "PREFIX": "De standaardrechtbank die hier is ingesteld, wordt verondersteld voor cliënten waar geen rechtbank is ingesteld.",
                    "JUSTICE_PEACE": "Standaard vredegerecht",
                    "LABOUR_COURT": "Standaard arbeidsrechtbank",
                    "NO_JUSTICE_PEACE": "Geen standaard vredegerecht",
                    "NO_LABOUR_COURT": "Geen standaard arbeidsrechtbank"
                },
                "LOGO": {
                    "HEADER": "Logo",
                    "ADD": "Logo toevoegen",
                    "EDIT": "Logo wijzigen",
                    "CLEAR": "Logo wissen"
                },
                "CC_ACCESS": {
                    "HEADER": "Toegang tot mijn kantoor",
                    "TOGGLE": {
                        "LABEL": "Geef ROOV toestemming om toegang te hebben tot mijn kantoor voor ondersteuning"
                    },
                    "NOT_GRANTED": "Er werd geen toestemming gegeven.",
                    "GRANTED": "Toestemming werd gegeven door {{ user }} op {{ date }}.",
                    "REVOKED": "Toestemming werd ingetrokken door {{ user }} op {{ date }}."
                }
            },
            "USERS": {
                "FILTER": {
                    "SHOW_BLOCKED": {
                        "LABEL": "Geblokkeerde gebruikers"
                    }
                },
                "COLUMN": {
                    "NAME": {
                        "HEADER": "Naam"
                    },
                    "EMAIL": {
                        "HEADER": "E-mail"
                    },
                    "DEFAULT": {
                        "HEADER": "Standaard"
                    }
                },
                "DEFAULT": {
                    "ADMINISTRATOR": "Bewindvoerder",
                    "DEBT_MEDIATOR": "Schuldbemiddelaar"
                },
                "BLOCKED": "Geblokkeerd",
                "ACTIONS": {
                    "EDIT": "Bewerken",
                    "SET_DEFAULT_ADMINISTRATOR": "Standaard bewindvoerder",
                    "SET_DEFAULT_DEBT_MEDIATOR": "Standaard schuldbemiddelaar",
                    "BLOCK": "Blokkeren",
                    "UNBLOCK": "Blokkering opheffen",
                    "REVOKE_INVITATION": "Uitnodiging intrekken"
                },
                "BUTTON": {
                    "ADD": {
                        "LABEL": "Gebruiker uitnodigen"
                    }
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "Nieuwe gebruiker"
                    },
                    "EDIT": {
                        "TITLE": "Gebruiker bewerken"
                    },
                    "ERROR": {
                        "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                        "EMAIL": "Ongeldig e-mailadres"
                    }
                },
                "PERSONAL": {
                    "TITLE": "Persoonsgegevens",
                    "FIRSTNAME": "Voornaam",
                    "LASTNAME": "Familienaam",
                    "EMAIL": "E-mail"
                },
                "ROLE": {
                    "TITLE": "Gebruikersrol",
                    "ADMIN": {
                        "LABEL": "Beheerder",
                        "DESCRIPTION": "Deze rol laat toe om de gebruikers van dit kantoor te beheren"
                    }
                },
                "EMPTY": "Geen gebruikers gevonden",
                "INVITED": "Uitgenodigd"
            },
            "CATEGORIES": {
                "LABEL": "Categorieën",
                "BUTTON": {
                    "ADD": "Categorie toevoegen"
                },
                "FILTERS": {
                    "MAIN": {
                        "ALL": "Alle hoofdcategorieën"
                    },
                    "CUSTOM": {
                        "LABEL": "Enkel eigen categorieën"
                    },
                    "MAPPING": {
                        "NONE": "Selecteer een arrondissement"
                    }
                },
                "ACTIONS": {
                    "EDIT": "Bewerken",
                    "DELETE": "Verwijderen"
                },
                "MAIN": {
                    "LABEL": "Hoofdcategorie"
                },
                "SUB": {
                    "LABEL": "Subcategorie"
                },
                "TABLE": {
                    "EMPTY": "Er werden geen categorieën gevonden"
                },
                "DIALOG": {
                    "ADD": {
                        "TITLE": "Nieuwe categorie",
                        "CATEGORY": {
                            "TITLE": "Categorie"
                        }
                    },
                    "ERROR": {
                        "REQUIRED": "Categorie is verplicht",
                        "DUPLICATE": "Deze categorie bestaat al"
                    },
                    "EDIT": {
                        "TITLE": "Categorie bewerken",
                        "CATEGORY": {
                            "TITLE": "Categorie"
                        }
                    },
                    "DELETE": {
                        "TITLE": "Categorie verwijderen",
                        "CATEGORY": {
                            "TITLE": "Categorie"
                        },
                        "REASSIGN": {
                            "TITLE": "Hercategorisering verrichtingen",
                            "DETAILS": "{{ count }} verrichtingen met deze categorie toewijzen aan:",
                            "CATEGORY": {
                                "PLACEHOLDER": "Selecteer een categorie"
                            },
                            "DETAILS_EMPTY": "Er zijn geen verrichtingen met deze categorie",
                            "DETAILS_SINGLE": "1 verrichting met deze categorie toewijzen aan:"
                        },
                        "USED_IN_CLIENT_BUDGET": {
                            "TITLE": "Opgenomen in budgetplannen",
                            "INFO": "Deze categorie is opgenomen in de budgetplannen van onderstaande cliënten en kan daarom niet verwijderd worden."
                        }
                    }
                },
                "MAPPING": {
                    "LABEL": "Corresponderende categorieën rapportering",
                    "CRBP": {
                        "LABEL": "CRBP"
                    },
                    "HONORARIUM": {
                        "LABEL": "Ereloon"
                    }
                }
            }
        },
        "EDIT_PAYMENT_DIALOG": {
            "TITLE": "Betaling bewerken"
        },
        "XS2A": {
            "TITLE": "Rekeningen toevoegen / autorisatie vernieuwen",
            "FINANCIAL_INSTITUTION": {
                "TITLE": "Bank"
            },
            "INSTRUCTIONS": {
                "TITLE": "Instructies",
                "REDIRECT_TO_BANK": "Wanneer je op “Bevestigen” klikt, word je omgeleid naar het portaal van de bank.",
                "AUTHENTICATE": "Meld je aan bij de bank (kaartlezer, itsMe...).",
                "SELECT_ALL": "Selecteer alle rekeningen die je wilt synchroniseren met ROOV Business (nieuwe en eerder toegevoegde).",
                "SELECT_ONE": "Selecteer de rekening die je wilt toevoegen aan ROOV Business of waarvoor je de autorisatie wilt vernieuwen.",
                "CONFIRM_SELECTION": "Bevestig je selectie.",
                "CONFIRM_GLOBAL": "Bevestig de toegang tot alle rekeningen.",
                "REDIRECT_TO_ROOV": "Je wordt teruggebracht naar ROOV Business.",
                "SELECT_FINANCIAL_INSTITUTION": "Selecteer de bank",
                "GKCCBEBB": "Selecteer de rekeningen (max. 100) die je wilt toevoegen of waarvoor je de autorisatie wenst te vernieuwen.",
                "GEBABEBB": "Selecteer de rekeningen die je wilt toevoegen of waarvoor je de autorisatie wenst te vernieuwen.",
                "BBRUBEBB": "Selecteer de rekeningen (max. 50) die je wilt toevoegen of waarvoor je de autorisatie wilt vernieuwen.",
                "CLICK_NEXT": "Klik op “Volgende”. Je krijgt een formulier te zien.",
                "ENTER_CUSTOMER_REFERENCE": "Vul indien gevraagd je klantnummer van de bank in.",
                "ENTER_IBANS": "Vul de IBAN’s in van de nieuwe rekeningen die je wilt toevoegen (laat leeg als je enkel de autorisatie van eerder toegevoegde rekeningen wilt vernieuwen).",
                "CONFIRM_TO_REDIRECT_TO_BANK": "Klik op “Bevestigen”. Je wordt omgeleid naar het portaal van de bank.",
                "CONFIRM_DETAILED": "Bevestig dat je ROOV / Augias Corp. toegang geeft tot de rekeningen.",
                "ENTER_IBANS_FOR_IMPORT": "Selecteer de IBAN's van de rekeningen waarvoor je de historiek wilt importeren.",
                "SELECT_ALL_FOR_IMPORT": "Selecteer de rekeningen waarvoor je de historiek wilt importeren, alsook de rekeningen die je wilt blijven synchroniseren.",
                "SELECT_ONE_FOR_IMPORT": "Selecteer de rekening waarvoor je de historiek wilt importeren.",
                "GKCCBEBB_FOR_IMPORT": "Selecteer de rekeningen (max. 100) waarvoor je de historiek wilt importeren.",
                "GEBABEBB_FOR_IMPORT": "Selecteer de rekeningen waarvoor je de historiek wilt importeren.",
                "BBRUBEBB_FOR_IMPORT": "Selecteer de rekeningen (max. 50) waarvoor je de historiek wilt importeren."
            },
            "IMPORTANT": {
                "TITLE": "Belangrijk",
                "FINANCIAL_INSTITUTION_OFFERED_1": "Selecteer niet alleen de nieuwe rekeningen die je wilt toevoegen of de rekeningen waarvoor je de autorisatie wilt vernieuwen. Selecteer alle rekeningen die je wilt synchroniseren met ROOV Business.",
                "FINANCIAL_INSTITUTION_OFFERED_2": "Als je een rekening die je al eerder toevoegde niet opnieuw selecteert, zal die niet langer synchroniseren en een foutstatus krijgen.",
                "GLOBAL": "Bij deze bank kan je niet kiezen welke rekeningen je wilt koppelen. Alle rekeningen waar je de nodige rechten op hebt wordt automatisch toegevoegd.",
                "SINGLE_1": "Er kan maar autorisatie verleend worden voor 1 rekening per keer.",
                "SINGLE_2": "Herhaal het proces voor elke rekening die je wilt toevoegen of waarvoor je de autorisatie wilt vernieuwen.",
                "GKCCBEBB_ERROR": "Bij Belfius is het mogelijk dat er een foutmelding optreedt wanneer teveel rekeningen ineens geselecteerd worden. Normaal gezien is het mogelijk om tot ±100 rekeningen te selecteren.",
                "GKCCBEBB_RETRY": "Krijg je toch een foutmelding, probeer het dan opnieuw met minder rekeningen.",
                "REPEAT": "Herhaal het proces tot al je rekeningen zijn toegevoegd of vernieuwd.",
                "GEBABEBB_ERROR": "Een vaak voorkomende foutmelding bij BNP Paribas Fortis, Fintro en Hello bank! is \"Lijst met rekeningen niet beschikbaar\". Dit kan in de meeste gevallen opgelost worden door zich aan te melden in het lokale BNP Paribas Fortis kantoor en de eID te laten uitlezen om de persoonsgegevens te actualiseren.",
                "BBRUBEBB_LIMIT": "Bij ING kan je maximaal 50 rekeningen ineens selecteren. Handig is dat de lijst van rekeningen wordt opgedeeld in pagina's van exact 50 rekeningen.",
                "KREDBEBB": "Een vaak voorkomend probleem bij KBC / CBC is dat niet alle rekeningen zichtbaar zijn. Dit wijst erop dat de machtigingen op die rekeningen niet toereikend zijn (volmacht is niet voldoende, titularis is nodig). Om dit op te lossen, neemt men contact op het het lokale KBC / CBC kantoor om de machtigingen aan te passen.",
                "DETAILED_1": "Er wordt aan de bank niet alleen autorisatie gevraagd voor nieuwe rekeningen. Ook voor alle eerder toegevoegde rekeningen wordt een nieuwe autorisatie gevraagd. Dit is nodig omdat die rekeningen anders niet meer zouden synchroniseren en een foutstatus zouden krijgen.",
                "DETAILED_2": "Als je geen toegang meer hebt tot een eerder toegevoegde rekening of als ze intussen werd afgesloten, dan moet die rekening gearchiveerd worden alvorens dit proces uit te voeren. Anders zal het volledige proces falen.",
                "DETAILED_1_FOR_IMPORT": "Zijn er rekeningen die nog niet via Isabel Connect werden gesynchroniseerd? Dan wordt ook voor die rekeningen een nieuwe autorisatie gevraagd aan de bank. Dit is nodig omdat die rekeningen anders niet meer zouden synchroniseren en een foutstatus zouden krijgen.",
                "DETAILED_2_FOR_IMPORT": "Als je geen toegang meer hebt tot één van de rekeningen vermeld in het voorgaande punt, of als zo een rekening intussen werd afgesloten, dan moet die rekening gearchiveerd worden alvorens dit proces uit te voeren. Anders zal het volledige proces falen.",
                "FINANCIAL_INSTITUTION_OFFERED_1_FOR_IMPORT": "Zijn er rekeningen die nog niet via Isabel Connect werden gesynchroniseerd? Selecteer dan ook deze rekeningen.",
                "FINANCIAL_INSTITUTION_OFFERED_2_FOR_IMPORT": "Als je zo een rekening vermeld in het voorgaande punt niet opnieuw selecteert, zal die niet langer synchroniseren en een foutstatus krijgen.",
                "GLOBAL_FOR_IMPORT": "Bij deze bank kan je niet kiezen welke rekeningen je wilt importeren. Alle rekeningen waar je de nodige rechten op hebt, worden automatisch geautoriseerd.",
                "SINGLE_2_FOR_IMPORT": "Herhaal het proces voor elke rekening waarvoor je de historiek wilt importeren.",
                "REPEAT_FOR_IMPORT": "Herhaal het proces tot de historiek is geïmporteerd voor alle rekeningen waarvoor je dat wilt."
            },
            "ERROR": {
                "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                "IBAN": "Ongeldig IBAN"
            },
            "CUSTOMER_REFERENCE": {
                "LABEL": "Klantnummer",
                "INFO": "Vul je klantnummer van {{ bank }} in."
            },
            "IBANS": {
                "LABEL": "Nieuwe rekeningen",
                "INFO": "Vul de IBAN’s in van de nieuwe rekeningen die je wilt toevoegen.",
                "PLACEHOLDER": "IBAN",
                "ADD": "Rekening toevoegen"
            },
            "ACTIVE_ACCOUNTS": {
                "LABEL": "Eerder toegevoegde rekeningen",
                "INFO": "Lijst van eerder toegevoegde rekeningen waarvoor een nieuwe autorisatie gevraagd wordt.",
                "LABEL_FOR_IMPORT": "Andere rekeningen",
                "INFO_FOR_IMPORT": "Lijst van rekeningen die nog niet via Isabel Connect werden gesynchroniseerd en waarvoor een nieuwe autorisatie gevraagd wordt."
            },
            "IMPORT": {
                "TITLE": "Historiek importeren"
            },
            "ACCOUNTS_FOR_IMPORT": {
                "LABEL": "Rekeningen te importeren",
                "INFO": "Selecteer de rekeningen waarvoor je de historiek wilt importeren."
            }
        },
        "XS2A_REDIRECT": {
            "FI_ERROR": {
                "TITLE": "Autorisatie niet gelukt",
                "INFO": "De bank gaf de volgende info:",
                "ERROR": "Foutmelding",
                "ERROR_DESCRIPTION": "Omschrijving",
                "WHAT_NOW": {
                    "TITLE": "Wat nu?",
                    "INFO_1": "Heb je zelf het proces geannuleerd? Start dan gewoon opnieuw.",
                    "INFO_2": "Lukte het niet om aan te melden bij de bank? Mogelijks is er een tijdelijk probleem bij de bank en kan je het later eens opnieuw proberen. Als het probleem zich blijft voordoen, is er waarschijnlijk iets mis met je klantinstellingen bij de bank. Neem dan contact op met je bankkantoor.",
                    "INFO_3": "Kreeg je een foutmelding bij de bank na aanmelden? In de meeste gevallen wijst dat op geen of onvoldoende toegang tot één of meerdere rekeningen waarvoor je autorisatie probeert te verlenen.\u2028Weet je over welke rekening(en) het gaat? Start het proces dan opnieuw zonder die rekening(en) of neem contact op met je bankkantoor om de rechten op de rekening(en) aan te passen.",
                    "INFO_4": "Heb je alles geprobeerd, maar lukt het toch niet? Bezorg ons alle nuttige info (klantnummer bij de bank, IBAN’s die je wilt autoriseren, adres en schermafdruk van de pagina met foutmelding bij de bank). Wij vragen na bij de bank wat er fout loopt."
                },
                "NO_AUTH": "Er werd geen autorisatie verleend."
            },
            "AIAR_AUTH_ERROR": {
                "TITLE": "Ophalen van rekeninginfo mislukt",
                "INFO": "Er ging iets mis bij het ophalen van de rekeningen waarvoor autorisatie werd verleend.\n\n\nDe bank bezorgde ons een code voor de succesvolle autorisatie van je rekeningen voor toegang vanuit ROOV Business.\n\nBij het ophalen van die rekeningen bij de bank aan de hand van de aangeleverde code liep het echter mis.\n\nHet proces werd dus niet voltooid. Er werden geen rekeningen toegevoegd en/of de autorisatie van de rekeningen werd niet vernieuwd.",
                "WHAT_NOW": {
                    "TITLE": "Wat nu?",
                    "INFO_1": "Mogelijks is er een tijdelijk probleem bij de bank. Het loont de moeite om het op een later moment eens opnieuw te proberen.",
                    "INFO_2": "Blijft dit probleem zich voordoen? Bezorg ons alle nuttige info (klantnummer bij de bank, IBAN’s die je wilt autoriseren, adres en schermafdruk van deze pagina). Wij vragen na bij de bank wat er fout loopt."
                }
            },
            "LOADING": "Bezig met verwerken...",
            "AIAR_AUTH": {
                "TITLE": "Succesvolle autorisatie",
                "ACCOUNTS": "Voor de volgende rekening(en) werd met succes autorisatie verleend:",
                "SYNCING": "De synchronisatie van saldo en verrichtingen is gestart.",
                "IMPORTANT": {
                    "TITLE": "Belangrijk",
                    "INFO_1": "Het kan even duren voor de rekeninginfo volledig gesynchroniseerd is, zeker voor nieuw toegevoegde rekeningen of wanneer autorisatie werd verleend voor een groot aantal rekeningen.",
                    "INFO_2": "De beschikbare historiek verschilt van bank tot bank. De meesten stellen de laatste 1, 2 of 5 jaar ter beschikking. Bij enkelen is dit beperkt tot 3 of 6 maanden."
                }
            },
            "TITLE": "Autorisatie rekeningen"
        },
        "ISABEL_REDIRECT": {
            "TITLE": "Isabel Connect instellen",
            "ISABEL_ERROR": {
                "TITLE": "Autorisatie niet gelukt",
                "NO_AUTH": "Er werd geen connectie ingesteld.",
                "INFO": "Isabel 6 gaf de volgende info:",
                "ERROR": "Foutmelding",
                "ERROR_DESCRIPTION": "Omschrijving"
            },
            "LOADING": "Bezig met verwerken...",
            "AUTH_ERROR": {
                "TITLE": "Koppelen met Isabel 6 mislukt.",
                "INFO": "Er ging iets mis bij het koppelen met Isabel 6.\n\n\nIsabel 6 bezorgde ons een code voor de succesvolle koppeling met ROOV Business.\n\nBij het valideren van de aangeleverde code liep het echter mis.\n\nHet proces werd dus niet voltooid."
            },
            "CONNECTED": {
                "TITLE": "Isabel Connect is actief"
            },
            "AUTHORIZED": {
                "SYNCING": "De synchronisatie van saldo en verrichtingen is gestart.",
                "IMPORTANT": {
                    "INFO_1": "Het kan even duren voor de rekeninginfo volledig gesynchroniseerd is.",
                    "INFO_2": "Standaard krijgen nieuwe rekeningen in Isabel 6 geen historiek mee van de bank en worden ze pas beschikbaar via Isabel Connect zodra een nieuwe verrichting wordt uitgevoerd. We vragen momenteel aan de banken om voor alle rekeningen 2 jaar historiek te voorzien.",
                    "TITLE": "Belangrijk"
                }
            }
        },
        "DOCUMENT_PAYMENT_DIALOG": {
            "TITLE": "Document betalen"
        },
        "DIALOG": {
            "QUEUED_ITEMS": {
                "SINGLE": "1 item te gaan",
                "MULTI": "{{count}} items te gaan"
            }
        },
        "PROCESS_DOCUMENT_DIALOG": {
            "TITLE": "Document verwerken",
            "BUTTON": {
                "PAY": {
                    "LABEL": "Betalen"
                },
                "ASSIGN": {
                    "LABEL": "Toewijzen"
                }
            },
            "ERROR": {
                "REQUIRED": "Niet alle verplichte velden zijn ingevuld",
                "REMITTANCE_INFORMATION": "Ongeldige mededeling",
                "MAT_DATEPICKER_MIN": "De uitvoeringsdatum mag niet in het verleden liggen",
                "MAT_DATEPICKER_PARSE": "Ongeldige datum",
                "MIN": "Het bedrag moet groter zijn dan 0",
                "EDITING": "Begunstigde moet eerst bewaard worden",
                "IBAN": "Ongeldig IBAN",
                "UNIQUE": "Er bestaat al een rekening met dit IBAN",
                "BENEFICIARY_NAME": "Ongeldige naam",
                "SAME_IBAN": "Rekeningnummer begunstigde is gelijk aan dat van de betaalrekening",
                "MAT_DATEPICKER_MAX": "De uitvoeringsdatum mag niet meer dan een jaar in de toekomst liggen",
                "DOCUMENT_NAME_EDITING": "Naam moet eerst bewaard worden"
            },
            "DELETE": {
                "TITLE": "Document verwijderen"
            }
        },
        "CC_ACCESS": {
            "MESSAGE": "Je bent ingelogd als {{ user }} in kantoor &quot;<strong>{{ office }}</strong>&quot;",
            "BUTTON": {
                "LABEL": "Sessie afsluiten"
            }
        },
        "TRANSACTION_CATEGORIES": {
            "MAIN_CATEGORY_SUFFIX": {
                "TRANSFERS_IN": " (inkomend)",
                "TRANSFERS_OUT": " (uitgaand)"
            }
        }
    },
    "NAVBAR": {
        "COLOR_MODE": {
            "dark": "Donkere modus",
            "light": "Lichte modus",
            "system": "Volg systeem"
        }
    },
    "PAGINATOR": {
        "FIRST_PAGE_LABEL": "Eerste pagina",
        "ITEMS_PER_PAGE_LABEL": "Items per pagina",
        "LAST_PAGE_LABEL": "Laatste pagina",
        "NEXT_PAGE_LABEL": "Volgende pagina",
        "PREVIOUS_PAGE_LABEL": "Vorige pagina",
        "EMPTY_RANGE_LABEL": "geen items",
        "RANGE_LABEL_OF": "van"
    },
    "SEARCH_FIELD": {
        "PLACEHOLDER": "Zoeken"
    },
    "FILTER_FIELD": {
        "PLACEHOLDER": "Filter"
    },
    "STATUS": {
        "ACTIVE": "Actief",
        "ARCHIVED": "Gearchiveerd"
    },
    "SELECT_FIELD": {
        "SEARCH": "Zoeken",
        "NOT_FOUND": "Geen items gevonden"
    },
    "MAINTENANCE": {
        "TITLE": "Onderhoud in uitvoering",
        "MESSAGE": "Onze excuses voor het ongemak, maar we zijn momenteel bezig met onderhoudswerkzaamheden. We zijn binnenkort weer online!"
    },
    "PDF_VIEWER": {
        "NEXT_PAGE": "Volgende pagina",
        "PREVIOUS_PAGE": "Vorige pagina"
    },
    "LOGOUT": {
        "TITLE": "Tot ziens",
        "MESSAGE": "De sessie is beëindigd. Sluit dit venster of meld je opnieuw aan bij ROOV Business.",
        "BUTTON": "Opnieuw aanmelden"
    },
    "AUTH": {
        "LOADING": "Autorisatie wordt geladen"
    },
    "DOCUMENT_VIEWER": {
        "ZOOM_OUT": "Uitzoomen",
        "ZOOM_IN": "Inzoomen",
        "ZOOM_1": "Zoomen tot 100%",
        "ZOOM_FIT_WIDTH": "Zoomen op breedte"
    }
}